var _path, _g, _path2, _path3, _g2, _path4, _path5, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _g7, _path11, _g8, _path12, _g9, _path13, _g10, _path14, _g11, _path15, _g12, _path16, _g13, _path17, _g14, _path18, _g15, _path19, _g16, _path20, _g17, _path21, _g18, _path22, _g19, _path23, _g20, _path24, _g21, _path25, _g22, _path26, _g23, _path27, _path28, _path29, _path30, _g24, _path31, _g25, _path32, _path33, _g26, _path34, _path35, _g27, _path36, _path37, _g28, _path38, _path39, _g29, _path40, _path41, _g30, _path42, _path43, _g31, _path44, _path45, _g32, _path46, _path47, _g33, _path48, _g34, _path49, _g35, _path50, _path51, _path52, _g36, _path53, _g37, _path54, _g38, _path55, _g39, _path56, _g40, _path57, _g41, _path58, _g42, _path59, _g43, _path60, _g44, _path61, _g45, _path62, _g46, _path63, _g47, _path64, _g48, _path65, _g49, _path66, _g50, _path67, _g51, _path68, _g52, _path69, _g53, _path70, _g54, _path71, _g55, _path72, _g56, _path73, _g57, _path74, _g58, _path75, _g59, _path76, _g60, _path77, _g61, _path78, _g62, _path79, _g63, _path80, _g64, _path81, _g65, _path82, _g66, _path83, _g67, _path84, _g68, _path85, _g69, _path86, _g70, _path87, _g71, _path88, _g72, _path89, _g73, _path90, _g74, _path91, _g75, _path92, _g76, _path93, _g77, _path94, _g78, _path95, _g79, _path96, _g80, _path97, _g81, _path98, _g82, _path99, _g83, _path100, _g84, _path101, _g85, _path102, _g86, _path103, _g87, _path104, _g88, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 187,
    viewBox: "0 0 86 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 19,
    height: 180
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3242 5.09338C15.3414 6.90938 13.2884 9.38005 13.2884 12.6267L13.4644 36.2934C11.2665 36.708 7.62556 37.472 7.01223 38.088C6.53223 38.5734 6.48956 39.184 6.55489 39.648L13.481 38.54L13.4873 39.3627L13.3357 39.2254C13.4482 41.6547 13.5169 43.3921 13.5174 43.4001C13.518 44.2774 13.5185 45.2361 13.5196 46.2694C13.5196 46.2694 13.5196 46.2694 13.519 46.2694C13.5196 46.4387 13.5201 46.6094 13.5201 46.78C13.5232 50.7014 13.5278 55.62 13.5336 61.152C13.5341 61.2787 13.5737 61.42 13.6441 61.572L13.6441 66.0294L10.5336 66.0294C9.38263 66.0294 8.44956 66.964 8.44956 68.1134L8.44957 184.22C8.44957 184.244 8.44957 184.268 8.4509 184.291C0.77757 182.781 0.77758 178.468 0.777579 171.681L0.777566 20.3467C0.777565 14.2707 9.92995 8.15072 18.3242 5.09338Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3242 5.09338C15.3414 6.90938 13.2884 9.38005 13.2884 12.6267L13.4644 36.2934C11.2665 36.708 7.62556 37.472 7.01223 38.088C6.53223 38.5734 6.48956 39.184 6.55489 39.648L13.481 38.54L13.4873 39.3627L13.3357 39.2254C13.4482 41.6547 13.5169 43.3921 13.5174 43.4001C13.518 44.2774 13.5185 45.2361 13.5196 46.2694C13.5196 46.2694 13.5196 46.2694 13.519 46.2694C13.5196 46.4387 13.5201 46.6094 13.5201 46.78C13.5232 50.7014 13.5278 55.62 13.5336 61.152C13.5341 61.2787 13.5737 61.42 13.6441 61.572L13.6441 66.0294L10.5336 66.0294C9.38263 66.0294 8.44956 66.964 8.44956 68.1134L8.44957 184.22C8.44957 184.244 8.44957 184.268 8.4509 184.291C0.77757 182.781 0.77758 178.468 0.777579 171.681L0.777566 20.3467C0.777565 14.2707 9.92995 8.15072 18.3242 5.09338Z",
    fill: "url(#paint0_linear_1_22238)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.965 61.1534L13.6442 61.1534L13.6442 66.5096L77.965 66.5096L77.965 61.1534Z",
    fill: "#696969"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 66,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5784 0.882694L56.0305 0.882692C57.0352 0.882692 58.1441 0.93335 59.3133 1.04002C59.0623 1.50535 58.8155 1.97071 58.5727 2.43471C58.4967 2.58538 58.4212 2.73603 58.3451 2.88536L32.2805 2.88536C32.2612 2.88536 32.242 2.88536 32.2227 2.88536C32.1472 2.73603 32.0712 2.58538 31.9951 2.43471C31.7701 2.00405 31.5415 1.57202 31.3092 1.14135C32.8425 0.965353 34.2945 0.882694 35.5784 0.882694ZM64.1169 1.74936C71.1321 3.19336 78.3223 6.55203 78.3223 12.6267L78.1445 36.2894C77.1649 36.104 76.4759 35.9907 76.4759 35.9907C76.4409 35.984 76.4071 35.9787 76.3737 35.9733C76.4753 35.9653 76.5769 35.956 76.6779 35.948C76.4217 35.6014 76.2556 35.2467 75.8389 34.916C75.516 34.5907 75.0259 34.292 74.5357 33.9974C74.1264 33.7734 73.604 33.528 73.0857 33.3134C74.3201 30.7254 76.6191 25.656 76.8123 23.3987C77.066 20.4174 76.7571 12.1094 76.7571 12.1094C76.0499 9.84668 74.742 8.13071 73.1259 6.83204C72.9988 6.62004 72.8477 6.38938 72.6696 6.13604C70.8117 3.49471 67.5133 3.07735 66.3956 3.07735C66.2884 3.07735 66.2008 3.08136 66.1373 3.0867C65.4081 3.15736 65.8368 3.57602 65.8368 3.57602L65.8461 3.58403C65.7832 3.56936 65.7201 3.55602 65.6571 3.54135C65.1623 2.93868 64.6461 2.34402 64.1169 1.74936ZM26.1941 2.03868C25.8893 2.38402 25.5893 2.73069 25.2956 3.07869C25.2565 3.07736 25.2128 3.07736 25.1655 3.07736C24.0477 3.07736 20.7488 3.49471 18.8904 6.13605C18.6363 6.49738 18.4379 6.81471 18.2847 7.09337C16.8269 8.35871 15.6493 9.99602 14.9868 12.1094C14.9868 12.1094 14.7336 20.4134 14.9336 23.3987C15.0712 25.464 16.9332 30.5374 18.0237 33.36C18.0305 33.5907 18.0384 33.82 18.0461 34.0507C17.8305 34.1774 17.6227 34.3107 17.4259 34.4427C17.2999 34.5294 17.1727 34.6174 17.0467 34.7067C16.0909 35.0827 15.7196 35.336 15.7196 35.336C15.7196 35.336 15.5993 35.5614 15.4144 35.9587C15.33 35.964 15.2409 35.9747 15.1477 35.992C15.1477 35.992 14.4513 36.1067 13.4644 36.2934L13.2884 12.6267C13.2884 9.38004 15.3415 6.90937 18.3243 5.09337C20.5784 3.72004 23.3644 2.71868 26.1941 2.03868ZM14.4456 38.3867C14.2931 38.8414 14.1441 39.3307 14.0128 39.8427L13.4873 39.3627L13.4811 38.54L14.4456 38.3867ZM77.48 38.4334L78.1275 38.5373L78.1185 39.6947L77.8253 39.9307C77.7368 39.4067 77.6227 38.9014 77.48 38.4334Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5784 0.882694L56.0305 0.882692C57.0352 0.882692 58.1441 0.93335 59.3133 1.04002C59.0623 1.50535 58.8155 1.97071 58.5727 2.43471C58.4967 2.58538 58.4212 2.73603 58.3451 2.88536L32.2805 2.88536C32.2612 2.88536 32.242 2.88536 32.2227 2.88536C32.1472 2.73603 32.0712 2.58538 31.9951 2.43471C31.7701 2.00405 31.5415 1.57202 31.3092 1.14135C32.8425 0.965353 34.2945 0.882694 35.5784 0.882694ZM64.1169 1.74936C71.1321 3.19336 78.3223 6.55203 78.3223 12.6267L78.1445 36.2894C77.1649 36.104 76.4759 35.9907 76.4759 35.9907C76.4409 35.984 76.4071 35.9787 76.3737 35.9733C76.4753 35.9653 76.5769 35.956 76.6779 35.948C76.4217 35.6014 76.2556 35.2467 75.8389 34.916C75.516 34.5907 75.0259 34.292 74.5357 33.9974C74.1264 33.7734 73.604 33.528 73.0857 33.3134C74.3201 30.7254 76.6191 25.656 76.8123 23.3987C77.066 20.4174 76.7571 12.1094 76.7571 12.1094C76.0499 9.84668 74.742 8.13071 73.1259 6.83204C72.9988 6.62004 72.8477 6.38938 72.6696 6.13604C70.8117 3.49471 67.5133 3.07735 66.3956 3.07735C66.2884 3.07735 66.2008 3.08136 66.1373 3.0867C65.4081 3.15736 65.8368 3.57602 65.8368 3.57602L65.8461 3.58403C65.7832 3.56936 65.7201 3.55602 65.6571 3.54135C65.1623 2.93868 64.6461 2.34402 64.1169 1.74936ZM26.1941 2.03868C25.8893 2.38402 25.5893 2.73069 25.2956 3.07869C25.2565 3.07736 25.2128 3.07736 25.1655 3.07736C24.0477 3.07736 20.7488 3.49471 18.8904 6.13605C18.6363 6.49738 18.4379 6.81471 18.2847 7.09337C16.8269 8.35871 15.6493 9.99602 14.9868 12.1094C14.9868 12.1094 14.7336 20.4134 14.9336 23.3987C15.0712 25.464 16.9332 30.5374 18.0237 33.36C18.0305 33.5907 18.0384 33.82 18.0461 34.0507C17.8305 34.1774 17.6227 34.3107 17.4259 34.4427C17.2999 34.5294 17.1727 34.6174 17.0467 34.7067C16.0909 35.0827 15.7196 35.336 15.7196 35.336C15.7196 35.336 15.5993 35.5614 15.4144 35.9587C15.33 35.964 15.2409 35.9747 15.1477 35.992C15.1477 35.992 14.4513 36.1067 13.4644 36.2934L13.2884 12.6267C13.2884 9.38004 15.3415 6.90937 18.3243 5.09337C20.5784 3.72004 23.3644 2.71868 26.1941 2.03868ZM14.4456 38.3867C14.2931 38.8414 14.1441 39.3307 14.0128 39.8427L13.4873 39.3627L13.4811 38.54L14.4456 38.3867ZM77.48 38.4334L78.1275 38.5373L78.1185 39.6947L77.8253 39.9307C77.7368 39.4067 77.6227 38.9014 77.48 38.4334Z",
    fill: "url(#paint1_radial_1_22238)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4723 13.5774C16.7707 13.5387 16.9816 13.2534 16.9847 12.9454C16.9945 11.7147 17.4649 10.532 18.3013 9.63071C18.5108 9.40404 18.5524 9.05203 18.3628 8.82003C18.1727 8.58536 17.7701 8.6027 17.504 8.88803C16.4811 9.9907 15.9065 11.4347 15.8951 12.936C15.8915 13.328 16.1748 13.616 16.4723 13.5774Z",
    fill: "#F7941E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1212 13.5774C74.8232 13.5387 74.6118 13.2534 74.6087 12.9454C74.5994 11.7147 74.1295 10.532 73.292 9.63071C73.0832 9.40404 73.0415 9.05203 73.23 8.82003C73.4207 8.58536 73.8238 8.6027 74.0894 8.88803C75.1123 9.9907 75.6874 11.4347 75.6994 12.936C75.7024 13.328 75.4191 13.616 75.1212 13.5774Z",
    fill: "#F7941E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 3,
    width: 8,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1655 3.07739C25.2128 3.07739 25.2565 3.07739 25.2956 3.07873C25.0732 3.34273 24.8545 3.60806 24.6399 3.87606C22.3879 4.50272 20.1149 5.50541 18.2847 7.09341C18.4379 6.81474 18.6363 6.49742 18.8904 6.13608C20.7488 3.49475 24.0477 3.07739 25.1655 3.07739Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1655 3.07739C25.2128 3.07739 25.2565 3.07739 25.2956 3.07873C25.0732 3.34273 24.8545 3.60806 24.6399 3.87606C22.3879 4.50272 20.1149 5.50541 18.2847 7.09341C18.4379 6.81474 18.6363 6.49742 18.8904 6.13608C20.7488 3.49475 24.0477 3.07739 25.1655 3.07739Z",
    fill: "url(#paint2_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 3,
    width: 9,
    height: 4
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3957 3.07733C67.5134 3.07733 70.8118 3.49469 72.6696 6.13602C72.8478 6.38936 72.9988 6.62002 73.1259 6.83202C71.0082 5.13069 68.3623 4.14401 65.8462 3.58401L65.8369 3.576C65.8369 3.576 65.4082 3.15734 66.1374 3.08667C66.2008 3.08134 66.2885 3.07733 66.3957 3.07733Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3957 3.07733C67.5134 3.07733 70.8118 3.49469 72.6696 6.13602C72.8478 6.38936 72.9988 6.62002 73.1259 6.83202C71.0082 5.13069 68.3623 4.14401 65.8462 3.58401L65.8369 3.576C65.8369 3.576 65.4082 3.15734 66.1374 3.08667C66.2008 3.08134 66.2885 3.07733 66.3957 3.07733Z",
    fill: "url(#paint3_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 2,
    width: 63,
    height: 32
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2806 2.88532L58.3451 2.88532C58.1967 3.18132 58.0494 3.4773 57.9024 3.7733C57.8008 3.6053 57.7456 3.51598 57.7456 3.51598L33.865 3.51598C33.865 3.51598 33.5879 3.96667 33.1384 4.732C32.8368 4.11733 32.5322 3.50132 32.2227 2.88532C32.242 2.88532 32.2612 2.88532 32.2806 2.88532ZM65.6571 3.54131C65.7202 3.55597 65.7832 3.56931 65.8462 3.58398C68.3623 4.14398 71.0082 5.13066 73.1259 6.83199C74.742 8.13066 76.0499 9.84664 76.7571 12.1093C76.7571 12.1093 77.066 20.4173 76.8123 23.3987C76.6191 25.656 74.3202 30.7253 73.0858 33.3133C72.9218 33.2453 72.7576 33.18 72.5983 33.12C72.5827 33.1133 72.5675 33.108 72.5519 33.1027C72.5655 32.6387 72.5775 32.172 72.5884 31.7027C72.6128 30.616 72.6306 29.5186 72.641 28.4066C72.6696 26.7973 72.6832 24.9906 72.5738 23.2106C72.465 21.4306 72.2306 19.676 71.8462 18.1653C71.4394 16.9467 71.0186 15.78 70.5904 14.6853C70.2076 10.0093 68.2134 6.65997 65.6571 3.54131ZM24.6399 3.87598C22.2144 6.89998 20.3462 10.176 19.9775 14.6853C19.5494 15.78 19.1284 16.9467 18.7218 18.1653C18.3379 19.676 18.1035 21.4306 17.9942 23.2106C17.8847 24.9906 17.8983 26.7973 17.927 28.4066C17.9374 29.5186 17.9551 30.616 17.9795 31.7027C17.9926 32.2573 18.0071 32.8107 18.0238 33.36C16.9332 30.5373 15.0712 25.464 14.9336 23.3987C14.7336 20.4133 14.9868 12.1093 14.9868 12.1093C15.6494 9.99598 16.827 8.35866 18.2847 7.09333C20.115 5.50533 22.3879 4.50264 24.6399 3.87598ZM30.1832 10.1027C27.8118 14.7227 25.3478 20.472 26.3691 22.7826C26.1655 22.8266 25.9612 22.8706 25.7571 22.916C25.756 22.24 25.7202 21.484 25.6738 20.58C26.0092 19.568 26.3723 18.5973 26.7472 17.688C27.017 14.236 28.5275 11.892 30.1832 10.1027Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2806 2.88532L58.3451 2.88532C58.1967 3.18132 58.0494 3.4773 57.9024 3.7733C57.8008 3.6053 57.7456 3.51598 57.7456 3.51598L33.865 3.51598C33.865 3.51598 33.5879 3.96667 33.1384 4.732C32.8368 4.11733 32.5322 3.50132 32.2227 2.88532C32.242 2.88532 32.2612 2.88532 32.2806 2.88532ZM65.6571 3.54131C65.7202 3.55597 65.7832 3.56931 65.8462 3.58398C68.3623 4.14398 71.0082 5.13066 73.1259 6.83199C74.742 8.13066 76.0499 9.84664 76.7571 12.1093C76.7571 12.1093 77.066 20.4173 76.8123 23.3987C76.6191 25.656 74.3202 30.7253 73.0858 33.3133C72.9218 33.2453 72.7576 33.18 72.5983 33.12C72.5827 33.1133 72.5675 33.108 72.5519 33.1027C72.5655 32.6387 72.5775 32.172 72.5884 31.7027C72.6128 30.616 72.6306 29.5186 72.641 28.4066C72.6696 26.7973 72.6832 24.9906 72.5738 23.2106C72.465 21.4306 72.2306 19.676 71.8462 18.1653C71.4394 16.9467 71.0186 15.78 70.5904 14.6853C70.2076 10.0093 68.2134 6.65997 65.6571 3.54131ZM24.6399 3.87598C22.2144 6.89998 20.3462 10.176 19.9775 14.6853C19.5494 15.78 19.1284 16.9467 18.7218 18.1653C18.3379 19.676 18.1035 21.4306 17.9942 23.2106C17.8847 24.9906 17.8983 26.7973 17.927 28.4066C17.9374 29.5186 17.9551 30.616 17.9795 31.7027C17.9926 32.2573 18.0071 32.8107 18.0238 33.36C16.9332 30.5373 15.0712 25.464 14.9336 23.3987C14.7336 20.4133 14.9868 12.1093 14.9868 12.1093C15.6494 9.99598 16.827 8.35866 18.2847 7.09333C20.115 5.50533 22.3879 4.50264 24.6399 3.87598ZM30.1832 10.1027C27.8118 14.7227 25.3478 20.472 26.3691 22.7826C26.1655 22.8266 25.9612 22.8706 25.7571 22.916C25.756 22.24 25.7202 21.484 25.6738 20.58C26.0092 19.568 26.3723 18.5973 26.7472 17.688C27.017 14.236 28.5275 11.892 30.1832 10.1027Z",
    fill: "url(#paint4_radial_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 3,
    width: 39,
    height: 21
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8649 3.51605L57.7456 3.51605C57.7456 3.51605 57.8008 3.60538 57.9024 3.77338C57.5925 4.39738 57.2868 5.02138 56.9841 5.64672C56.8341 5.95738 56.6857 6.26939 56.5363 6.58139L56.5363 6.58405C56.7279 6.72405 56.9191 6.86271 57.1112 7.00404C59.3649 9.18671 63.3649 11.8534 63.8207 17.6881C64.1956 18.5974 64.5592 19.5681 64.8945 20.5801C64.842 21.6041 64.8029 22.4374 64.8123 23.1801C58.6925 21.5987 52.5909 20.7734 46.3352 20.6867C46.3336 20.4654 46.3311 20.2427 46.3284 20.0201C45.7993 20.0067 45.2707 20.0001 44.7441 20.0001C38.5727 20.0001 32.6019 20.9281 27.0108 22.6481C26.7972 22.6921 26.5836 22.7374 26.3691 22.7827C25.3477 20.4721 27.8117 14.7227 30.1832 10.1027C31.3253 8.86674 32.5368 7.89471 33.4571 7.00404C33.6488 6.86271 33.8404 6.72272 34.0327 6.58272C33.8827 6.27072 33.7341 5.95872 33.5836 5.64672C33.4363 5.34139 33.2879 5.0374 33.1384 4.73207C33.5879 3.96674 33.8649 3.51605 33.8649 3.51605Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8649 3.51605L57.7456 3.51605C57.7456 3.51605 57.8008 3.60538 57.9024 3.77338C57.5925 4.39738 57.2868 5.02138 56.9841 5.64672C56.8341 5.95738 56.6857 6.26939 56.5363 6.58139L56.5363 6.58405C56.7279 6.72405 56.9191 6.86271 57.1112 7.00404C59.3649 9.18671 63.3649 11.8534 63.8207 17.6881C64.1956 18.5974 64.5592 19.5681 64.8945 20.5801C64.842 21.6041 64.8029 22.4374 64.8123 23.1801C58.6925 21.5987 52.5909 20.7734 46.3352 20.6867C46.3336 20.4654 46.3311 20.2427 46.3284 20.0201C45.7993 20.0067 45.2707 20.0001 44.7441 20.0001C38.5727 20.0001 32.6019 20.9281 27.0108 22.6481C26.7972 22.6921 26.5836 22.7374 26.3691 22.7827C25.3477 20.4721 27.8117 14.7227 30.1832 10.1027C31.3253 8.86674 32.5368 7.89471 33.4571 7.00404C33.6488 6.86271 33.8404 6.72272 34.0327 6.58272C33.8827 6.27072 33.7341 5.95872 33.5836 5.64672C33.4363 5.34139 33.2879 5.0374 33.1384 4.73207C33.5879 3.96674 33.8649 3.51605 33.8649 3.51605Z",
    fill: "url(#paint5_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 34,
    width: 66,
    height: 31
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0467 34.7067C17.0373 34.7133 17.0279 34.72 17.0185 34.7267C16.8925 34.828 16.7784 34.9427 16.6669 35.052C16.4175 35.32 16.1556 35.576 16.0311 35.8667C16.0139 35.9054 15.9977 35.944 15.9827 35.9827C15.9717 35.9947 15.9612 36.008 15.9503 36.0214C15.8217 35.98 15.6769 35.956 15.5144 35.956C15.4816 35.956 15.4483 35.9574 15.4144 35.9587C15.5993 35.5614 15.7196 35.336 15.7196 35.336C15.7196 35.336 16.0909 35.0827 17.0467 34.7067ZM73.1056 36.2547C73.4816 37.408 74.1655 39.104 74.7931 40.796C74.9717 41.2787 75.1551 41.4813 75.3295 41.4813C75.8357 41.4813 76.2623 39.768 76.2513 38.236L77.48 38.4334C77.6227 38.9014 77.7368 39.4067 77.8253 39.9307L75.1008 42.1187C75.1008 42.1187 75.4977 44.496 75.6827 48.1507C75.6821 48.1507 75.6816 48.152 75.6805 48.152C75.7425 49.3627 75.7811 50.712 75.7737 52.1614C75.7597 54.8814 75.5857 57.9533 75.1065 61.1147C75.1045 61.128 75.1024 61.14 75.1008 61.1533L78.0737 58.076L78.0737 58.0733C78.0769 55.6947 78.0789 53.76 78.0811 52.0813C78.0775 55.4667 78.0737 58.7747 78.0707 61.1533C78.0707 61.4373 78.0321 61.7013 77.9649 61.9467C77.4352 63.8627 75.1019 64.556 75.1019 64.556L16.5956 64.556C16.5956 64.556 14.1926 62.7547 13.6442 61.572C13.5738 61.42 13.5341 61.2787 13.5336 61.152C13.5279 55.62 13.5232 50.7013 13.5202 46.78C13.5207 47.0587 13.5207 47.34 13.5212 47.624C13.5238 50.5147 13.5269 53.8974 13.5305 57.628C13.5305 57.768 13.5336 57.912 13.5336 58.052C13.5336 58.0587 13.5336 58.0653 13.5336 58.0733L13.5336 58.076L16.5071 61.1534C16.5051 61.14 16.5035 61.128 16.5013 61.116C16.1508 58.8053 15.9639 56.5427 15.8827 54.4294C15.7946 52.1107 15.8341 49.9733 15.9269 48.152C15.9264 48.152 15.9259 48.1507 15.9254 48.1507C16.1098 44.496 16.5071 42.1187 16.5071 42.1187L14.0128 39.8427C14.1441 39.3307 14.2931 38.8414 14.4456 38.3867L15.3717 38.2387C15.3608 39.7693 15.7873 41.4827 16.2941 41.4827C16.468 41.4827 16.6519 41.28 16.8305 40.7974C17.3003 39.5307 17.8013 38.2614 18.1816 37.22C18.1967 37.504 18.2117 37.7867 18.2284 38.068C18.1925 39.388 18.0789 40.6733 17.8545 41.904C17.9144 42.092 17.9753 42.2774 18.0379 42.46C17.718 44.6987 17.4712 47.216 17.4712 49.6534C17.4712 59.3947 19.48 64.556 19.48 64.556L72.1253 64.556C72.1253 64.556 74.1379 58.8813 74.1379 49.6533C74.1379 44.7427 72.9675 38.9773 72.4201 36.548C72.4237 36.4693 72.4275 36.392 72.4311 36.3133C72.656 36.2933 72.8805 36.2747 73.1056 36.2547ZM13.5175 43.4C13.518 44.2774 13.5191 45.236 13.5202 46.2694L13.5196 46.2694C13.5185 45.236 13.518 44.2774 13.5175 43.4ZM78.0909 43.4C78.0899 44.296 78.0884 45.2627 78.0873 46.2694C78.0873 46.2707 78.0873 46.2693 78.0873 46.2707C78.0884 45.2627 78.0899 44.296 78.0909 43.4Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0467 34.7067C17.0373 34.7133 17.0279 34.72 17.0185 34.7267C16.8925 34.828 16.7784 34.9427 16.6669 35.052C16.4175 35.32 16.1556 35.576 16.0311 35.8667C16.0139 35.9054 15.9977 35.944 15.9827 35.9827C15.9717 35.9947 15.9612 36.008 15.9503 36.0214C15.8217 35.98 15.6769 35.956 15.5144 35.956C15.4816 35.956 15.4483 35.9574 15.4144 35.9587C15.5993 35.5614 15.7196 35.336 15.7196 35.336C15.7196 35.336 16.0909 35.0827 17.0467 34.7067ZM73.1056 36.2547C73.4816 37.408 74.1655 39.104 74.7931 40.796C74.9717 41.2787 75.1551 41.4813 75.3295 41.4813C75.8357 41.4813 76.2623 39.768 76.2513 38.236L77.48 38.4334C77.6227 38.9014 77.7368 39.4067 77.8253 39.9307L75.1008 42.1187C75.1008 42.1187 75.4977 44.496 75.6827 48.1507C75.6821 48.1507 75.6816 48.152 75.6805 48.152C75.7425 49.3627 75.7811 50.712 75.7737 52.1614C75.7597 54.8814 75.5857 57.9533 75.1065 61.1147C75.1045 61.128 75.1024 61.14 75.1008 61.1533L78.0737 58.076L78.0737 58.0733C78.0769 55.6947 78.0789 53.76 78.0811 52.0813C78.0775 55.4667 78.0737 58.7747 78.0707 61.1533C78.0707 61.4373 78.0321 61.7013 77.9649 61.9467C77.4352 63.8627 75.1019 64.556 75.1019 64.556L16.5956 64.556C16.5956 64.556 14.1926 62.7547 13.6442 61.572C13.5738 61.42 13.5341 61.2787 13.5336 61.152C13.5279 55.62 13.5232 50.7013 13.5202 46.78C13.5207 47.0587 13.5207 47.34 13.5212 47.624C13.5238 50.5147 13.5269 53.8974 13.5305 57.628C13.5305 57.768 13.5336 57.912 13.5336 58.052C13.5336 58.0587 13.5336 58.0653 13.5336 58.0733L13.5336 58.076L16.5071 61.1534C16.5051 61.14 16.5035 61.128 16.5013 61.116C16.1508 58.8053 15.9639 56.5427 15.8827 54.4294C15.7946 52.1107 15.8341 49.9733 15.9269 48.152C15.9264 48.152 15.9259 48.1507 15.9254 48.1507C16.1098 44.496 16.5071 42.1187 16.5071 42.1187L14.0128 39.8427C14.1441 39.3307 14.2931 38.8414 14.4456 38.3867L15.3717 38.2387C15.3608 39.7693 15.7873 41.4827 16.2941 41.4827C16.468 41.4827 16.6519 41.28 16.8305 40.7974C17.3003 39.5307 17.8013 38.2614 18.1816 37.22C18.1967 37.504 18.2117 37.7867 18.2284 38.068C18.1925 39.388 18.0789 40.6733 17.8545 41.904C17.9144 42.092 17.9753 42.2774 18.0379 42.46C17.718 44.6987 17.4712 47.216 17.4712 49.6534C17.4712 59.3947 19.48 64.556 19.48 64.556L72.1253 64.556C72.1253 64.556 74.1379 58.8813 74.1379 49.6533C74.1379 44.7427 72.9675 38.9773 72.4201 36.548C72.4237 36.4693 72.4275 36.392 72.4311 36.3133C72.656 36.2933 72.8805 36.2747 73.1056 36.2547ZM13.5175 43.4C13.518 44.2774 13.5191 45.236 13.5202 46.2694L13.5196 46.2694C13.5185 45.236 13.518 44.2774 13.5175 43.4ZM78.0909 43.4C78.0899 44.296 78.0884 45.2627 78.0873 46.2694C78.0873 46.2707 78.0873 46.2693 78.0873 46.2707C78.0884 45.2627 78.0899 44.296 78.0909 43.4Z",
    fill: "url(#paint6_radial_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 36,
    width: 58,
    height: 29
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4201 36.548C72.9675 38.9774 74.1379 44.7427 74.1379 49.6534C74.1379 58.8814 72.1254 64.556 72.1254 64.556L19.48 64.556C19.48 64.556 17.4712 59.3947 17.4712 49.6534C17.4712 47.216 17.718 44.6987 18.0379 42.4601C18.1926 42.9107 18.3556 43.3427 18.529 43.7601C18.6566 44.0454 18.7841 44.324 18.9103 44.592C18.9779 44.5934 19.0462 44.5934 19.115 44.5934C19.3436 44.5934 19.5723 44.588 19.8003 44.5747C20.854 44.4267 21.8967 44.1294 22.9269 43.6894C23.968 43.092 25.0019 42.3507 26.0342 41.4694C26.3358 41.1867 26.6374 40.8907 26.9394 40.5827C26.8227 40.412 26.7071 40.2374 26.589 40.0587C26.13 39.3214 25.7056 38.4267 25.3169 37.3507C25.192 37.152 25.079 36.952 24.9764 36.7494C25.0342 36.7494 25.0925 36.7494 25.1503 36.7494C26.8305 36.7494 28.5103 36.7494 30.1904 36.7494L30.3425 36.7547L30.556 36.7707L30.8404 36.804L31.0598 36.8387C31.203 36.856 31.3394 36.8774 31.4702 36.8987C31.7384 36.9454 31.9415 36.9947 32.1836 37.0547C32.5336 37.1254 32.8546 37.2027 33.1442 37.2894C33.2894 37.3334 33.4264 37.3774 33.5556 37.4214C33.7347 37.476 33.9139 37.528 34.0931 37.58C34.1202 37.58 34.0873 37.5707 34.2311 37.544L34.3685 37.5027L34.6103 37.4507C35.2633 37.3014 36.3821 37.128 37.6269 36.9894C40.1769 36.7134 43.2488 36.5734 46.3081 36.5681C49.404 36.5734 52.5118 36.7134 55.0868 36.9947C56.3431 37.132 57.4665 37.312 58.1065 37.4587C58.3117 37.4947 58.3696 37.5254 58.4723 37.5494L58.5623 37.576L58.5723 37.58L58.5811 37.58L58.5909 37.5774L58.6035 37.58L58.6046 37.58C58.5994 37.5827 58.5967 37.5827 58.5972 37.5827C58.5999 37.5827 58.7467 37.5387 58.8936 37.4934C58.9169 37.4867 58.9404 37.4787 58.9633 37.472C59.4779 37.4267 59.9925 37.384 60.5076 37.3387C62.1743 37.196 63.8409 37.052 65.5081 36.9094C65.4284 37.0574 65.3431 37.204 65.2508 37.3507C64.8623 38.4267 64.4379 39.3214 63.9789 40.0587C63.8612 40.2374 63.7451 40.412 63.6289 40.5827C63.9305 40.8907 64.2321 41.1867 64.5336 41.4694C65.5665 42.3507 66.6003 43.092 67.6409 43.6894C68.6712 44.1294 69.7139 44.4267 70.7675 44.5747C70.9956 44.588 71.2243 44.5934 71.4529 44.5934C71.5217 44.5934 71.5899 44.5934 71.6581 44.592C71.7836 44.324 71.9112 44.0454 72.0389 43.76C72.2821 43.1734 72.506 42.5587 72.7133 41.904C72.4889 40.6734 72.3753 39.3881 72.3399 38.0681C72.3685 37.5641 72.3956 37.0574 72.4201 36.548ZM59.0723 37.4387C59.0393 37.448 59.0024 37.46 58.9633 37.472C58.9581 37.472 58.9524 37.4734 58.9467 37.4734L58.9546 37.4707L59.0259 37.4507L59.0617 37.44L59.0723 37.4387ZM58.9467 37.4734L58.8133 37.5107L58.5909 37.5774L58.5702 37.5734L58.515 37.5547L58.4612 37.516C58.6232 37.5014 58.7852 37.4867 58.9467 37.4734Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.4201 36.548C72.9675 38.9774 74.1379 44.7427 74.1379 49.6534C74.1379 58.8814 72.1254 64.556 72.1254 64.556L19.48 64.556C19.48 64.556 17.4712 59.3947 17.4712 49.6534C17.4712 47.216 17.718 44.6987 18.0379 42.4601C18.1926 42.9107 18.3556 43.3427 18.529 43.7601C18.6566 44.0454 18.7841 44.324 18.9103 44.592C18.9779 44.5934 19.0462 44.5934 19.115 44.5934C19.3436 44.5934 19.5723 44.588 19.8003 44.5747C20.854 44.4267 21.8967 44.1294 22.9269 43.6894C23.968 43.092 25.0019 42.3507 26.0342 41.4694C26.3358 41.1867 26.6374 40.8907 26.9394 40.5827C26.8227 40.412 26.7071 40.2374 26.589 40.0587C26.13 39.3214 25.7056 38.4267 25.3169 37.3507C25.192 37.152 25.079 36.952 24.9764 36.7494C25.0342 36.7494 25.0925 36.7494 25.1503 36.7494C26.8305 36.7494 28.5103 36.7494 30.1904 36.7494L30.3425 36.7547L30.556 36.7707L30.8404 36.804L31.0598 36.8387C31.203 36.856 31.3394 36.8774 31.4702 36.8987C31.7384 36.9454 31.9415 36.9947 32.1836 37.0547C32.5336 37.1254 32.8546 37.2027 33.1442 37.2894C33.2894 37.3334 33.4264 37.3774 33.5556 37.4214C33.7347 37.476 33.9139 37.528 34.0931 37.58C34.1202 37.58 34.0873 37.5707 34.2311 37.544L34.3685 37.5027L34.6103 37.4507C35.2633 37.3014 36.3821 37.128 37.6269 36.9894C40.1769 36.7134 43.2488 36.5734 46.3081 36.5681C49.404 36.5734 52.5118 36.7134 55.0868 36.9947C56.3431 37.132 57.4665 37.312 58.1065 37.4587C58.3117 37.4947 58.3696 37.5254 58.4723 37.5494L58.5623 37.576L58.5723 37.58L58.5811 37.58L58.5909 37.5774L58.6035 37.58L58.6046 37.58C58.5994 37.5827 58.5967 37.5827 58.5972 37.5827C58.5999 37.5827 58.7467 37.5387 58.8936 37.4934C58.9169 37.4867 58.9404 37.4787 58.9633 37.472C59.4779 37.4267 59.9925 37.384 60.5076 37.3387C62.1743 37.196 63.8409 37.052 65.5081 36.9094C65.4284 37.0574 65.3431 37.204 65.2508 37.3507C64.8623 38.4267 64.4379 39.3214 63.9789 40.0587C63.8612 40.2374 63.7451 40.412 63.6289 40.5827C63.9305 40.8907 64.2321 41.1867 64.5336 41.4694C65.5665 42.3507 66.6003 43.092 67.6409 43.6894C68.6712 44.1294 69.7139 44.4267 70.7675 44.5747C70.9956 44.588 71.2243 44.5934 71.4529 44.5934C71.5217 44.5934 71.5899 44.5934 71.6581 44.592C71.7836 44.324 71.9112 44.0454 72.0389 43.76C72.2821 43.1734 72.506 42.5587 72.7133 41.904C72.4889 40.6734 72.3753 39.3881 72.3399 38.0681C72.3685 37.5641 72.3956 37.0574 72.4201 36.548ZM59.0723 37.4387C59.0393 37.448 59.0024 37.46 58.9633 37.472C58.9581 37.472 58.9524 37.4734 58.9467 37.4734L58.9546 37.4707L59.0259 37.4507L59.0617 37.44L59.0723 37.4387ZM58.9467 37.4734L58.8133 37.5107L58.5909 37.5774L58.5702 37.5734L58.515 37.5547L58.4612 37.516C58.6232 37.5014 58.7852 37.4867 58.9467 37.4734Z",
    fill: "url(#paint7_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 35,
    width: 4,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9826 35.9827C15.9769 35.9973 15.9706 36.012 15.9649 36.0267C15.9602 36.0253 15.9556 36.024 15.9502 36.0213C15.9612 36.008 15.9717 35.9947 15.9826 35.9827ZM16.6956 36.7493C17.0764 36.7493 17.457 36.7493 17.8378 36.7493C17.9445 36.7493 18.0513 36.7493 18.1576 36.7493C18.1654 36.9067 18.1732 37.064 18.1816 37.22C17.8013 38.2613 17.3002 39.5307 16.8305 40.7973C16.6518 41.28 16.468 41.4827 16.2941 41.4827C15.7873 41.4827 15.3608 39.7693 15.3717 38.2387L16.9341 37.988C16.9217 37.572 16.8602 37.1213 16.6956 36.7493Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9826 35.9827C15.9769 35.9973 15.9706 36.012 15.9649 36.0267C15.9602 36.0253 15.9556 36.024 15.9502 36.0213C15.9612 36.008 15.9717 35.9947 15.9826 35.9827ZM16.6956 36.7493C17.0764 36.7493 17.457 36.7493 17.8378 36.7493C17.9445 36.7493 18.0513 36.7493 18.1576 36.7493C18.1654 36.9067 18.1732 37.064 18.1816 37.22C17.8013 38.2613 17.3002 39.5307 16.8305 40.7973C16.6518 41.28 16.468 41.4827 16.2941 41.4827C15.7873 41.4827 15.3608 39.7693 15.3717 38.2387L16.9341 37.988C16.9217 37.572 16.8602 37.1213 16.6956 36.7493Z",
    fill: "url(#paint8_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 35,
    width: 11,
    height: 5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5144 35.956C15.6769 35.956 15.8217 35.98 15.9503 36.0214C15.9556 36.024 15.9603 36.0254 15.9649 36.0267C15.8737 36.2667 15.8155 36.5094 15.7909 36.7494C16.0925 36.7494 16.3941 36.7494 16.6956 36.7494C16.8603 37.1214 16.9217 37.572 16.9341 37.988L15.3717 38.2387L14.4456 38.3867L13.4811 38.54L6.55494 39.648C6.48961 39.184 6.53228 38.5734 7.01228 38.088C7.62561 37.472 11.2665 36.708 13.4644 36.2934C14.4513 36.1067 15.1477 35.992 15.1477 35.992C15.2409 35.9747 15.33 35.964 15.4144 35.9587C15.4483 35.9574 15.4816 35.956 15.5144 35.956Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5144 35.956C15.6769 35.956 15.8217 35.98 15.9503 36.0214C15.9556 36.024 15.9603 36.0254 15.9649 36.0267C15.8737 36.2667 15.8155 36.5094 15.7909 36.7494C16.0925 36.7494 16.3941 36.7494 16.6956 36.7494C16.8603 37.1214 16.9217 37.572 16.9341 37.988L15.3717 38.2387L14.4456 38.3867L13.4811 38.54L6.55494 39.648C6.48961 39.184 6.53228 38.5734 7.01228 38.088C7.62561 37.472 11.2665 36.708 13.4644 36.2934C14.4513 36.1067 15.1477 35.992 15.1477 35.992C15.2409 35.9747 15.33 35.964 15.4144 35.9587C15.4483 35.9574 15.4816 35.956 15.5144 35.956Z",
    fill: "url(#paint9_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 37,
    width: 11,
    height: 4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9341 37.988C16.9565 38.6507 16.8623 39.2227 16.8623 39.2227L6.72825 40.328C6.72825 40.328 6.60692 40.04 6.55492 39.648L16.9341 37.988Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9341 37.988C16.9565 38.6507 16.8623 39.2227 16.8623 39.2227L6.72825 40.328C6.72825 40.328 6.60692 40.04 6.55492 39.648L16.9341 37.988Z",
    fill: "url(#paint10_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 36,
    width: 4,
    height: 6
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6232 36.0387C74.9056 36.312 74.7123 37.2107 74.6894 37.9867L76.2514 38.236C76.2623 39.768 75.8358 41.4813 75.3295 41.4813C75.1551 41.4813 74.9718 41.2787 74.7931 40.796C74.1655 39.104 73.4816 37.408 73.1056 36.2547C73.629 36.2093 74.1524 36.1653 74.6764 36.12C74.992 36.092 75.3076 36.0653 75.6232 36.0387Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6232 36.0387C74.9056 36.312 74.7123 37.2107 74.6894 37.9867L76.2514 38.236C76.2623 39.768 75.8358 41.4813 75.3295 41.4813C75.1551 41.4813 74.9718 41.2787 74.7931 40.796C74.1655 39.104 73.4816 37.408 73.1056 36.2547C73.629 36.2093 74.1524 36.1653 74.6764 36.12C74.992 36.092 75.3076 36.0653 75.6232 36.0387Z",
    fill: "url(#paint11_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 35,
    width: 12,
    height: 5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3738 35.9734C76.4071 35.9787 76.441 35.984 76.4759 35.9907C76.4759 35.9907 77.165 36.104 78.1446 36.2894C80.341 36.7027 83.9962 37.4694 84.6103 38.0867C85.0915 38.572 85.1333 39.184 85.0681 39.6467L78.1275 38.5374L77.4801 38.4334L76.2514 38.2361L74.6894 37.9867C74.7123 37.2107 74.9057 36.312 75.6233 36.0387C75.8738 36.0174 76.1238 35.996 76.3738 35.9734Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.3738 35.9734C76.4071 35.9787 76.441 35.984 76.4759 35.9907C76.4759 35.9907 77.165 36.104 78.1446 36.2894C80.341 36.7027 83.9962 37.4694 84.6103 38.0867C85.0915 38.572 85.1333 39.184 85.0681 39.6467L78.1275 38.5374L77.4801 38.4334L76.2514 38.2361L74.6894 37.9867C74.7123 37.2107 74.9057 36.312 75.6233 36.0387C75.8738 36.0174 76.1238 35.996 76.3738 35.9734Z",
    fill: "url(#paint12_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 37,
    width: 12,
    height: 4
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6894 37.9867C74.6666 38.6494 74.7609 39.2214 74.7609 39.2214L84.8957 40.3267C84.8957 40.3267 85.0161 40.0387 85.0681 39.6467L74.6894 37.9867Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.6894 37.9867C74.6666 38.6494 74.7609 39.2214 74.7609 39.2214L84.8957 40.3267C84.8957 40.3267 85.0161 40.0387 85.0681 39.6467L74.6894 37.9867Z",
    fill: "url(#paint13_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 2,
    width: 25,
    height: 2
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8649 3.51603L57.7456 3.51602L56.2827 2.66003L35.33 2.66004L33.8649 3.51603Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8649 3.51603L57.7456 3.51602L56.2827 2.66003L35.33 2.66004L33.8649 3.51603Z",
    fill: "url(#paint14_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 39,
    width: 4,
    height: 23
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3357 39.2253L13.4873 39.3627L14.0128 39.8427L16.5071 42.1187C16.5071 42.1187 16.1098 44.496 15.9254 48.1507C15.1284 47.4933 14.315 46.86 13.5202 46.2694C13.5191 45.236 13.518 44.2773 13.5175 43.4C13.5169 43.392 13.4483 41.6547 13.3357 39.2253ZM13.5212 47.624C13.5248 50.3187 13.5279 53.3013 13.5336 58.052C13.5336 57.912 13.5305 57.768 13.5305 57.628C13.5269 53.8973 13.5238 50.5147 13.5212 47.624ZM15.8827 54.4293C15.9639 56.5427 16.1508 58.8053 16.5013 61.116C16.1503 58.804 15.9634 56.5413 15.8827 54.4293Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3357 39.2253L13.4873 39.3627L14.0128 39.8427L16.5071 42.1187C16.5071 42.1187 16.1098 44.496 15.9254 48.1507C15.1284 47.4933 14.315 46.86 13.5202 46.2694C13.5191 45.236 13.518 44.2773 13.5175 43.4C13.5169 43.392 13.4483 41.6547 13.3357 39.2253ZM13.5212 47.624C13.5248 50.3187 13.5279 53.3013 13.5336 58.052C13.5336 57.912 13.5305 57.768 13.5305 57.628C13.5269 53.8973 13.5238 50.5147 13.5212 47.624ZM15.8827 54.4293C15.9639 56.5427 16.1508 58.8053 16.5013 61.116C16.1503 58.804 15.9634 56.5413 15.8827 54.4293Z",
    fill: "url(#paint15_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 46,
    width: 1,
    height: 1
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5191 46.2694C13.5196 46.2694 13.5196 46.2694 13.5196 46.2694C13.5196 46.4374 13.5201 46.608 13.5201 46.78C13.5201 46.6094 13.5196 46.4387 13.5191 46.2694Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5496,
    y: 47.4667,
    width: 2.02667,
    height: 2.02669,
    transform: "rotate(180 14.5496 47.4667)",
    fill: "url(#pattern0)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 46,
    width: 4,
    height: 16
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5196 46.2694L13.5201 46.2694C13.5207 46.708 13.5207 47.1587 13.5212 47.624C13.5207 47.34 13.5207 47.0587 13.5201 46.78C13.5201 46.608 13.5196 46.4374 13.5196 46.2694ZM15.9254 48.1507C15.9259 48.1507 15.9264 48.152 15.9269 48.152C15.8341 49.9734 15.7945 52.1107 15.8827 54.4294C15.7941 52.1094 15.8332 49.972 15.9254 48.1507ZM16.5013 61.116C16.5035 61.128 16.5051 61.14 16.5071 61.1534C16.5051 61.1414 16.5029 61.128 16.5013 61.116Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.7496,
    y: 62.2667,
    width: 5.22665,
    height: 16.8267,
    transform: "rotate(180 17.7496 62.2667)",
    fill: "url(#pattern1)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 46,
    width: 4,
    height: 16
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5201 46.2694C14.3149 46.86 15.1284 47.4934 15.9254 48.1507C15.8332 49.972 15.7941 52.1094 15.8827 54.4294C15.9633 56.5414 16.1503 58.804 16.5013 61.116C16.5029 61.128 16.5051 61.1414 16.5071 61.1534L13.5336 58.076L13.5336 58.0734C13.5336 58.0654 13.5336 58.0587 13.5336 58.052C13.5279 53.3014 13.5248 50.3187 13.5212 47.624C13.5207 47.1587 13.5207 46.708 13.5201 46.2694Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.7496,
    y: 62.2667,
    width: 5.22665,
    height: 16.8267,
    transform: "rotate(180 17.7496 62.2667)",
    fill: "url(#pattern2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 39,
    width: 4,
    height: 23
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2494 39.5907C78.1503 41.8347 78.091 43.4 78.091 43.4C78.0899 44.296 78.0885 45.2627 78.0874 46.2707C77.2931 46.86 76.4779 47.4947 75.6827 48.1507C75.4978 44.496 75.1009 42.1187 75.1009 42.1187L77.8254 39.9307L78.1186 39.6947L78.2494 39.5907ZM75.7738 52.1614C75.7609 54.88 75.5869 57.9507 75.1066 61.1147C75.5858 57.9534 75.7598 54.8814 75.7738 52.1614Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2494 39.5907C78.1503 41.8347 78.091 43.4 78.091 43.4C78.0899 44.296 78.0885 45.2627 78.0874 46.2707C77.2931 46.86 76.4779 47.4947 75.6827 48.1507C75.4978 44.496 75.1009 42.1187 75.1009 42.1187L77.8254 39.9307L78.1186 39.6947L78.2494 39.5907ZM75.7738 52.1614C75.7609 54.88 75.5869 57.9507 75.1066 61.1147C75.5858 57.9534 75.7598 54.8814 75.7738 52.1614Z",
    fill: "url(#paint16_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 46,
    width: 1,
    height: 7
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0884 46.2694C78.0858 48.0414 78.0836 49.8294 78.0811 52.0814C78.0832 50.1147 78.0852 48.1214 78.0874 46.2694C78.0879 46.2694 78.0879 46.2694 78.0884 46.2694Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0884 46.2694C78.0858 48.0414 78.0836 49.8294 78.0811 52.0814C78.0832 50.1147 78.0852 48.1214 78.0874 46.2694C78.0879 46.2694 78.0879 46.2694 78.0884 46.2694Z",
    fill: "url(#paint17_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 46,
    width: 4,
    height: 16
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0873 46.2694C78.0852 48.1214 78.0832 50.1147 78.0811 52.0814C78.0789 53.76 78.0769 55.6947 78.0737 58.0734L78.0737 58.048C78.0779 54.4987 78.0827 50.0853 78.0873 46.2707C78.0873 46.2693 78.0873 46.2707 78.0873 46.2694ZM75.6827 48.1507C75.7436 49.3614 75.7816 50.7107 75.7737 52.1614C75.7811 50.712 75.7425 49.3627 75.6805 48.152C75.6816 48.152 75.6821 48.1507 75.6827 48.1507Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.2163,
    y: 62.2667,
    width: 5.22667,
    height: 16.8267,
    transform: "rotate(180 79.2163 62.2667)",
    fill: "url(#pattern3)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 46,
    width: 4,
    height: 16
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0873 46.2707C78.0827 50.0854 78.0779 54.4987 78.0737 58.048L78.0737 58.0734L78.0737 58.076L75.1008 61.1534C75.1024 61.14 75.1045 61.128 75.1065 61.1147C75.5868 57.9507 75.7608 54.88 75.7737 52.1614C75.7816 50.7107 75.7436 49.3614 75.6827 48.1507C76.4779 47.4947 77.2931 46.86 78.0873 46.2707Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.2163,
    y: 62.2667,
    width: 5.22667,
    height: 16.8267,
    transform: "rotate(180 79.2163 62.2667)",
    fill: "url(#pattern4)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6445 56.0907C13.304 56.0907 13.0284 55.8067 13.0284 55.4574L13.0284 50.2001C13.0284 49.8507 13.304 49.5641 13.6445 49.5641L13.6445 56.0907Z",
    fill: "#E3E3E3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.091 56.0907C78.4306 56.0907 78.7061 55.8067 78.7061 55.4574L78.7061 50.2001C78.7061 49.8507 78.4306 49.5641 78.091 49.5641L78.091 56.0907Z",
    fill: "#C9C9C9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8045 31.34C54.2649 31.0773 72.7289 34.5373 72.7217 34.704C72.7207 34.704 71.7217 27.04 71.9065 25.6627L71.9451 25.3614C71.8175 25.3174 71.6899 25.272 71.5623 25.228C62.6827 22.14 53.9691 20.644 44.9103 20.68C37.2936 20.7187 29.1904 21.8307 20.1409 24.3053C20.0128 24.34 19.8852 24.376 19.7571 24.4107L19.7519 24.7134C19.6893 28.592 19.2816 34.7294 19.2816 34.7294C19.2743 34.572 37.3451 31.1027 45.8045 31.34Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 21,
    width: 43,
    height: 11
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2999 21.0867C51.9341 21.0867 58.3519 21.9427 64.8248 23.6413C64.8341 23.8453 64.8477 24.0427 64.8669 24.236C58.3477 22.3654 51.8389 21.4133 45.106 21.4133C39.8352 21.4133 34.4275 21.9973 28.7675 23.1787C31.2696 22.48 33.8461 21.9413 36.4784 21.576C39.4764 21.2493 42.4081 21.0867 45.2999 21.0867ZM25.6212 24.8453C26.0499 27.028 26.4779 29.2107 26.906 31.396C26.0519 31.544 25.1868 31.712 24.3076 31.9067C24.2087 31.9293 24.1108 31.9507 24.0128 31.972C24.0212 31.7507 24.0352 31.528 24.0546 31.3014C24.1508 30.1667 24.3723 28.9813 24.6128 27.776C25.1603 26.648 25.4686 25.76 25.6212 24.8453ZM65.0123 25.1933C65.1816 25.9893 65.4775 26.792 65.9551 27.776C66.1956 28.9813 66.4169 30.1667 66.5133 31.3014C66.5201 31.38 66.5259 31.4574 66.5316 31.5347C65.627 31.3654 64.7352 31.22 63.8535 31.092C64.2399 29.1253 64.6264 27.1587 65.0123 25.1933Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2999 21.0867C51.9341 21.0867 58.3519 21.9427 64.8248 23.6413C64.8341 23.8453 64.8477 24.0427 64.8669 24.236C58.3477 22.3654 51.8389 21.4133 45.106 21.4133C39.8352 21.4133 34.4275 21.9973 28.7675 23.1787C31.2696 22.48 33.8461 21.9413 36.4784 21.576C39.4764 21.2493 42.4081 21.0867 45.2999 21.0867ZM25.6212 24.8453C26.0499 27.028 26.4779 29.2107 26.906 31.396C26.0519 31.544 25.1868 31.712 24.3076 31.9067C24.2087 31.9293 24.1108 31.9507 24.0128 31.972C24.0212 31.7507 24.0352 31.528 24.0546 31.3014C24.1508 30.1667 24.3723 28.9813 24.6128 27.776C25.1603 26.648 25.4686 25.76 25.6212 24.8453ZM65.0123 25.1933C65.1816 25.9893 65.4775 26.792 65.9551 27.776C66.1956 28.9813 66.4169 30.1667 66.5133 31.3014C66.5201 31.38 66.5259 31.4574 66.5316 31.5347C65.627 31.3654 64.7352 31.22 63.8535 31.092C64.2399 29.1253 64.6264 27.1587 65.0123 25.1933Z",
    fill: "url(#paint18_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 21,
    width: 41,
    height: 11
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1061 21.4133C51.839 21.4133 58.3478 22.3654 64.867 24.236C64.8733 24.3027 64.8806 24.3694 64.8885 24.4347C64.9186 24.6907 64.9593 24.9413 65.0123 25.1933C64.6265 27.1587 64.2399 29.1253 63.8535 31.092C62.8369 30.9453 61.8327 30.8213 60.8363 30.708C55.9655 30.184 51.2462 29.9907 46.5503 29.9747L46.0681 29.9747C41.415 29.9933 36.7385 30.1827 31.9109 30.7C30.2707 30.884 28.6103 31.1 26.9061 31.396C26.4779 29.2107 26.0499 27.028 25.6213 24.8453C25.6442 24.7093 25.6634 24.5734 25.6795 24.4347C25.6921 24.332 25.7025 24.228 25.7118 24.1227C26.7175 23.7813 27.7358 23.4667 28.7675 23.1787C34.4275 21.9973 39.8353 21.4133 45.1061 21.4133Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.7497,
    y: 32.1334,
    width: 41.0933,
    height: 11.6267,
    transform: "rotate(180 65.7497 32.1334)",
    fill: "url(#pattern5)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 66,
    width: 76,
    height: 121
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5337 186.304L81.0765 186.304C82.227 186.304 83.1598 185.372 83.1598 184.22L83.1598 68.1134C83.1598 66.964 82.227 66.0294 81.0765 66.0294L10.5337 66.0294C9.38272 66.0294 8.44965 66.964 8.44965 68.1134L8.44966 184.22C8.44966 185.372 9.38273 186.304 10.5337 186.304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_1_22238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 81,
    width: 5,
    height: 96
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5327 81.0067C80.7415 81.0067 81.9509 81.0067 83.1598 81.0067L83.1598 176.216L79.5327 176.216L79.5327 81.0067Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.283,
    y: 177.467,
    width: 5.89333,
    height: 97.4933,
    transform: "rotate(180 84.283 177.467)",
    fill: "url(#pattern6)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 66,
    width: 76,
    height: 121
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5337 186.304L81.0765 186.304C82.227 186.304 83.1598 185.372 83.1598 184.22L83.1598 68.1134C83.1598 66.964 82.227 66.0294 81.0765 66.0294L10.5337 66.0294C9.38272 66.0294 8.44965 66.964 8.44965 68.1134L8.44966 184.22C8.44966 185.372 9.38273 186.304 10.5337 186.304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_1_22238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 81,
    width: 5,
    height: 96
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44964 81.0067C9.65818 81.0067 10.8686 81.0067 12.0775 81.0067L12.0775 176.216L8.44965 176.216L8.44964 81.0067Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.3497,
    y: 177.467,
    width: 6.02665,
    height: 97.4933,
    transform: "rotate(180 13.3497 177.467)",
    fill: "url(#pattern7)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 66,
    width: 76,
    height: 121
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5337 186.304L81.0765 186.304C82.227 186.304 83.1598 185.372 83.1598 184.22L83.1598 68.1134C83.1598 66.964 82.227 66.0294 81.0765 66.0294L10.5337 66.0294C9.38272 66.0294 8.44965 66.964 8.44965 68.1134L8.44966 184.22C8.44966 185.372 9.38273 186.304 10.5337 186.304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_1_22238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask30_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 181,
    width: 52,
    height: 6
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5885 181.727L72.8186 181.727L72.8186 186.304L21.5885 186.304C21.5885 184.777 21.5885 183.252 21.5885 181.727Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.1497,
    y: 187.067,
    width: 53.36,
    height: 6.56003,
    transform: "rotate(180 74.1497 187.067)",
    fill: "url(#pattern8)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 66,
    width: 76,
    height: 121
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5337 186.304L81.0765 186.304C82.227 186.304 83.1598 185.372 83.1598 184.22L83.1598 68.1134C83.1598 66.964 82.227 66.0294 81.0765 66.0294L10.5337 66.0294C9.38272 66.0294 8.44965 66.964 8.44965 68.1134L8.44966 184.22C8.44966 185.372 9.38273 186.304 10.5337 186.304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_1_22238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 176,
    width: 12,
    height: 11
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5327 176.216L83.1598 176.216L83.1598 184.22C83.1598 185.372 82.227 186.304 81.0765 186.304L72.8186 186.304L72.8186 181.727L79.5327 181.727L79.5327 176.216Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.283,
    y: 187.067,
    width: 12.2933,
    height: 11.76,
    transform: "rotate(180 84.283 187.067)",
    fill: "url(#pattern9)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 66,
    width: 76,
    height: 121
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5337 186.304L81.0765 186.304C82.227 186.304 83.1598 185.372 83.1598 184.22L83.1598 68.1134C83.1598 66.964 82.227 66.0294 81.0765 66.0294L10.5337 66.0294C9.38272 66.0294 8.44965 66.964 8.44965 68.1134L8.44966 184.22C8.44966 185.372 9.38273 186.304 10.5337 186.304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_1_22238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 176,
    width: 14,
    height: 11
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4497 176.216L12.0776 176.216L12.0776 181.727L21.5885 181.727C21.5885 183.252 21.5885 184.777 21.5885 186.304L10.5337 186.304C9.38277 186.304 8.4497 185.372 8.4497 184.22L8.4497 176.216Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.9497,
    y: 187.067,
    width: 15.4933,
    height: 11.76,
    transform: "rotate(180 22.9497 187.067)",
    fill: "url(#pattern10)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 66,
    width: 76,
    height: 121
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5337 186.304L81.0765 186.304C82.227 186.304 83.1598 185.372 83.1598 184.22L83.1598 68.1134C83.1598 66.964 82.227 66.0294 81.0765 66.0294L10.5337 66.0294C9.38272 66.0294 8.44965 66.964 8.44965 68.1134L8.44966 184.22C8.44966 185.372 9.38273 186.304 10.5337 186.304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_1_22238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask36_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 66,
    width: 52,
    height: 6
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5885 66.0294L72.8186 66.0294L72.8186 71.4947L21.5885 71.4947C21.5885 69.6734 21.5885 67.8507 21.5885 66.0294Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.1497,
    y: 72.4,
    width: 53.36,
    height: 7.09336,
    transform: "rotate(180 74.1497 72.4)",
    fill: "url(#pattern11)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 66,
    width: 76,
    height: 121
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5337 186.304L81.0765 186.304C82.227 186.304 83.1598 185.372 83.1598 184.22L83.1598 68.1134C83.1598 66.964 82.227 66.0294 81.0765 66.0294L10.5337 66.0294C9.38272 66.0294 8.44965 66.964 8.44965 68.1134L8.44966 184.22C8.44966 185.372 9.38273 186.304 10.5337 186.304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_1_22238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 66,
    width: 12,
    height: 16
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8186 66.0294L81.0765 66.0294C82.227 66.0294 83.1598 66.964 83.1598 68.1134L83.1598 81.0067C81.9509 81.0067 80.7415 81.0067 79.5327 81.0067L79.5327 71.4947L72.8186 71.4947L72.8186 66.0294Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.283,
    y: 82.0001,
    width: 12.2933,
    height: 16.6933,
    transform: "rotate(180 84.283 82.0001)",
    fill: "url(#pattern12)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 66,
    width: 76,
    height: 121
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5337 186.304L81.0765 186.304C82.227 186.304 83.1598 185.372 83.1598 184.22L83.1598 68.1134C83.1598 66.964 82.227 66.0294 81.0765 66.0294L10.5337 66.0294C9.38272 66.0294 8.44965 66.964 8.44965 68.1134L8.44966 184.22C8.44966 185.372 9.38273 186.304 10.5337 186.304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_1_22238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 66,
    width: 14,
    height: 16
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5336 66.0294L21.5884 66.0294C21.5884 67.8507 21.5884 69.6734 21.5884 71.4947L12.0775 71.4947L12.0775 81.0067C10.8686 81.0067 9.65817 81.0067 8.44964 81.0067L8.44964 68.1134C8.44964 66.964 9.38271 66.0294 10.5336 66.0294Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.9496,
    y: 82.0001,
    width: 15.4933,
    height: 16.6933,
    transform: "rotate(180 22.9496 82.0001)",
    fill: "url(#pattern13)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 71,
    width: 68,
    height: 111
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0775 71.4947L45.4713 71.4947L45.4713 181.727L46.1379 181.727L46.1379 71.4947L72.8186 71.4947L79.5327 71.4947L79.5327 81.0067L79.5327 176.216L79.5327 181.727L72.8186 181.727L21.5885 181.727L12.0775 181.727L12.0775 176.216L12.0775 81.0067L12.0775 71.4947Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0775 71.4947L45.4713 71.4947L45.4713 181.727L46.1379 181.727L46.1379 71.4947L72.8186 71.4947L79.5327 71.4947L79.5327 81.0067L79.5327 176.216L79.5327 181.727L72.8186 181.727L21.5885 181.727L12.0775 181.727L12.0775 176.216L12.0775 81.0067L12.0775 71.4947Z",
    fill: "url(#paint19_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 71,
    width: 2,
    height: 111
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1378 71.4947L45.4712 71.4947L45.4712 181.726L46.1378 181.726L46.1378 71.4947Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1378 71.4947L45.4712 71.4947L45.4712 181.726L46.1378 181.726L46.1378 71.4947Z",
    fill: "url(#paint20_linear_1_22238)"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M22.23 25.432C29.5774 22.392 37.7784 20.8014 46.3378 21.028C46.3357 20.6934 46.3326 20.3574 46.3284 20.02C37.6393 19.7974 29.3092 21.416 21.8404 24.508C21.9717 24.816 22.1013 25.124 22.23 25.432Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4685 21.0894C37.4685 21.6907 40.1222 22.1774 43.3966 22.1774C46.6712 22.1774 49.3253 21.6907 49.3253 21.0894C49.3253 20.4881 46.6712 20.0001 43.3966 20.0001C40.1222 20.0001 37.4685 20.4881 37.4685 21.0894Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 31,
    width: 15,
    height: 1
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7696 31.3254C48.6696 31.3254 50.9565 31.4747 53.3743 31.7107C51.2445 31.6027 48.9603 31.5427 46.5123 31.5427C46.2795 31.5427 46.0431 31.544 45.8071 31.5454C45.456 31.5427 45.1112 31.5427 44.768 31.5427C42.9103 31.5427 41.1633 31.5654 39.5237 31.6094C41.4941 31.4347 43.3477 31.328 44.9341 31.328C45.2347 31.328 45.5243 31.332 45.8045 31.34C46.1133 31.3307 46.4357 31.3254 46.7696 31.3254Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.2829,
    y: 32.8,
    width: 15.4933,
    height: 2.69336,
    transform: "rotate(180 54.2829 32.8)",
    fill: "url(#pattern14)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 31,
    width: 43,
    height: 4
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M44.768 31.5427C45.1112 31.5427 45.456 31.5427 45.8071 31.5453C46.0431 31.544 46.2795 31.5427 46.5123 31.5427C48.9603 31.5427 51.2446 31.6027 53.3743 31.7107C57.8368 32.1467 62.7467 32.8773 66.5046 33.508C66.479 33.7253 66.4456 33.9387 66.403 34.1507C61.2894 33.2867 53.5508 32.3453 45.8123 32.344C45.8051 32.344 45.7967 32.344 45.789 32.344C37.5092 32.344 29.2322 33.32 24.1675 34.1627C24.1404 34.0294 24.1166 33.8947 24.0967 33.7587C28.2134 33.028 34.2852 32.076 39.5238 31.6093C41.1634 31.5653 42.9103 31.5427 44.768 31.5427Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.7496,
    y: 35.3333,
    width: 44.96,
    height: 4.56003,
    transform: "rotate(180 67.7496 35.3333)",
    fill: "url(#pattern15)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 32,
    width: 43,
    height: 6
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M45.789 32.344C45.7967 32.344 45.8051 32.344 45.8123 32.344C53.5508 32.3453 61.2894 33.2867 66.403 34.1507C66.3779 34.2747 66.3494 34.3973 66.3175 34.5187C66.1822 35.3307 65.927 36.1307 65.5082 36.9093C63.841 37.052 62.1743 37.196 60.5076 37.3387C59.9926 37.384 59.4779 37.4267 58.9634 37.472C59.0024 37.46 59.0394 37.448 59.0723 37.4387L59.0618 37.44L59.0259 37.4507L58.9546 37.4707L58.9467 37.4733C58.7852 37.4867 58.6232 37.5013 58.4612 37.516L58.515 37.5547L58.5702 37.5733L58.591 37.5773L58.5811 37.58L58.5723 37.58L58.5623 37.576L58.4723 37.5493C58.3696 37.5253 58.3118 37.4947 58.1066 37.4587C57.4666 37.312 56.3431 37.132 55.0868 36.9947C52.5118 36.7133 49.404 36.5734 46.3082 36.568C43.2488 36.5734 40.177 36.7133 37.627 36.9893C36.3822 37.128 35.2634 37.3013 34.6103 37.4507L34.3686 37.5027L34.2311 37.544C34.0874 37.5707 34.1202 37.58 34.0931 37.58C33.9139 37.528 33.7347 37.476 33.5556 37.4213C33.4264 37.3773 33.2894 37.3333 33.1442 37.2893C32.8546 37.2027 32.5336 37.1253 32.1836 37.0547C31.9415 36.9947 31.7384 36.9454 31.4702 36.8987C31.3394 36.8774 31.203 36.856 31.0598 36.8387L30.8404 36.804L30.556 36.7707L30.3426 36.7547L30.1904 36.7493C28.5103 36.7493 26.8305 36.7493 25.1503 36.7493C25.0925 36.7493 25.0342 36.7493 24.9764 36.7493C24.6066 36.0213 24.3769 35.276 24.2503 34.5187C24.2196 34.4013 24.192 34.2827 24.1675 34.1627C29.2322 33.32 37.5092 32.344 45.789 32.344Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.7496,
    y: 38.5334,
    width: 44.2933,
    height: 7.22669,
    transform: "rotate(180 67.7496 38.5334)",
    fill: "url(#pattern16)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 31,
    width: 43,
    height: 3
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0112 31.2454C51.9191 31.2454 57.8279 31.816 63.4847 32.9707C63.5259 32.7627 63.5669 32.5534 63.6076 32.344C64.5967 32.5174 65.5789 32.7054 66.5519 32.9094C66.5425 33.1107 66.5269 33.3107 66.5045 33.508C62.7467 32.8774 57.8368 32.1467 53.3743 31.7107C50.9565 31.4747 48.6696 31.3254 46.7696 31.3254C46.4357 31.3254 46.1134 31.3307 45.8046 31.34C45.5243 31.332 45.2347 31.328 44.9341 31.328C43.3477 31.328 41.4941 31.4347 39.5237 31.6094C34.2852 32.076 28.2133 33.028 24.0967 33.7587C24.0769 33.624 24.0603 33.4867 24.0472 33.3494C25.0748 33.116 26.1144 32.8974 27.1612 32.696C27.1942 32.8667 27.2275 33.036 27.2608 33.2067C33.3008 31.9054 39.6556 31.2454 46.0112 31.2454Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.7496,
    y: 34.6667,
    width: 44.96,
    height: 4.56003,
    transform: "rotate(180 67.7496 34.6667)",
    fill: "url(#pattern17)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 31,
    width: 43,
    height: 3
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8535 31.092C64.7352 31.22 65.6269 31.3654 66.5316 31.5347C66.5639 32.0027 66.5732 32.4614 66.5519 32.9094C65.5789 32.7054 64.5967 32.5174 63.6076 32.344C63.6899 31.9267 63.7717 31.5094 63.8535 31.092ZM26.906 31.396C26.9909 31.8294 27.0764 32.2627 27.1612 32.696C26.1144 32.8974 25.0748 33.116 24.0472 33.3494C24.0045 32.9027 23.9956 32.4427 24.0128 31.972C24.1108 31.9507 24.2087 31.9294 24.3076 31.9067C25.1868 31.712 26.0519 31.544 26.906 31.396Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.7496,
    y: 34.6667,
    width: 44.96,
    height: 4.56003,
    transform: "rotate(180 67.7496 34.6667)",
    fill: "url(#pattern18)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 30,
    width: 37,
    height: 4
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4592 30.8947C52.256 30.8947 58.0461 31.372 63.6076 32.344C63.5669 32.5534 63.5259 32.7627 63.4847 32.9707C57.8279 31.816 51.9191 31.2454 46.0112 31.2454C39.6556 31.2454 33.3008 31.9054 27.2608 33.2067C27.2275 33.036 27.1941 32.8667 27.1612 32.6961C33.3847 31.5027 39.9248 30.8947 46.4592 30.8947Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.5496,
    y: 34.0001,
    width: 38.56,
    height: 3.89336,
    transform: "rotate(180 64.5496 34.0001)",
    fill: "url(#pattern19)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 29,
    width: 38,
    height: 4
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M46.068 29.9747L46.5503 29.9747C51.2462 29.9907 55.9655 30.184 60.8363 30.708C61.8327 30.8213 62.8368 30.9454 63.8535 31.092C63.7718 31.5094 63.6899 31.9267 63.6076 32.344C58.0462 31.372 52.256 30.8947 46.4592 30.8947C39.9248 30.8947 33.3847 31.5027 27.1612 32.696C27.0764 32.2627 26.991 31.8294 26.906 31.396C28.6103 31.1 30.2707 30.884 31.9108 30.7C36.7384 30.1827 41.415 29.9933 46.068 29.9747Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.083,
    y: 33.4667,
    width: 39.0933,
    height: 4.69336,
    transform: "rotate(180 65.083 33.4667)",
    fill: "url(#pattern20)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 33,
    width: 5,
    height: 3
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0858 33.3134C73.604 33.528 74.1264 33.7734 74.5358 33.9974C75.0259 34.292 75.516 34.5907 75.839 34.916C76.2556 35.2467 76.4218 35.6014 76.6779 35.948C76.577 35.956 76.4754 35.9653 76.3738 35.9733C76.2806 35.9613 76.1926 35.9547 76.1087 35.9547C76.0508 35.9547 75.9951 35.9574 75.9415 35.964C75.8279 35.888 75.7093 35.8253 75.5842 35.7733C75.4973 35.7373 75.4071 35.7 75.3155 35.664C74.8352 35.2854 74.2437 35.1374 73.7566 35.0867C73.3661 34.952 72.9472 34.816 72.4999 34.6787C72.5003 34.6627 72.5008 34.648 72.5014 34.632C72.642 34.668 72.718 34.692 72.7218 34.7027L72.7218 34.704C72.7218 34.7027 72.7218 34.7027 72.7218 34.7027C72.7196 34.688 72.6957 34.5054 72.6571 34.2014C72.7765 33.9574 72.9218 33.6574 73.0858 33.3134Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.883,
    y: 37.2,
    width: 6.42667,
    height: 5.22669,
    transform: "rotate(180 77.883 37.2)",
    fill: "url(#pattern21)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 33,
    width: 2,
    height: 2
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5519 33.1027C72.5675 33.1081 72.5827 33.1134 72.5983 33.12C72.7576 33.18 72.9218 33.2454 73.0858 33.3134C72.9218 33.6574 72.7764 33.9574 72.6571 34.2014C72.6275 33.9681 72.5894 33.6627 72.5456 33.3054C72.5483 33.2374 72.5499 33.1707 72.5519 33.1027Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.1496,
    y: 35.3333,
    width: 2.69333,
    height: 3.36003,
    transform: "rotate(180 74.1496 35.3333)",
    fill: "url(#pattern22)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 34,
    width: 4,
    height: 3
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4999 34.6787C72.9473 34.816 73.3661 34.952 73.7566 35.0867C73.5874 35.0694 73.4306 35.0627 73.2957 35.0627C73.0077 35.0627 72.8186 35.0907 72.8186 35.0907C72.8327 35.34 72.939 35.744 73.1057 36.2547C72.8806 36.2747 72.6561 36.2933 72.4311 36.3133C72.4566 35.772 72.479 35.2267 72.4999 34.6787ZM75.3155 35.664C75.4071 35.7 75.4973 35.7373 75.5842 35.7733C75.7093 35.8253 75.8279 35.888 75.9415 35.964C75.8451 35.9734 75.7557 35.9934 75.6727 36.02C75.5645 35.8827 75.4442 35.7654 75.3155 35.664Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.683,
    y: 37.2,
    width: 5.22667,
    height: 3.22669,
    transform: "rotate(180 76.683 37.2)",
    fill: "url(#pattern23)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 35,
    width: 4,
    height: 2
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2957 35.0627C73.4306 35.0627 73.5874 35.0694 73.7566 35.0867C74.2437 35.1374 74.8353 35.2854 75.3155 35.664C75.4442 35.7654 75.5645 35.8827 75.6727 36.02C75.6561 36.0267 75.6394 36.032 75.6233 36.0387C75.3077 36.0654 74.9921 36.092 74.6765 36.12C74.1525 36.1654 73.629 36.2094 73.1057 36.2547C72.939 35.744 72.8327 35.34 72.8186 35.0907C72.8186 35.0907 73.0077 35.0627 73.2957 35.0627Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.683,
    y: 37.2,
    width: 4.69333,
    height: 3.22669,
    transform: "rotate(180 76.683 37.2)",
    fill: "url(#pattern24)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 35,
    width: 2,
    height: 2
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1087 35.9547C76.1926 35.9547 76.2806 35.9613 76.3738 35.9733C76.1238 35.996 75.8738 36.0173 75.6232 36.0387C75.6394 36.032 75.656 36.0267 75.6727 36.02C75.7556 35.9933 75.8451 35.9734 75.9415 35.964C75.9951 35.9574 76.0508 35.9547 76.1087 35.9547Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.3496,
    y: 37.2,
    width: 2.69333,
    height: 2.02669,
    transform: "rotate(180 77.3496 37.2)",
    fill: "url(#pattern25)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 33,
    width: 1,
    height: 2
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5456 33.3054C72.5893 33.6627 72.6275 33.9681 72.6571 34.2014C72.6956 34.5054 72.7196 34.6881 72.7217 34.7027C72.718 34.6921 72.642 34.6681 72.5013 34.6321C72.5175 34.1921 72.5327 33.7494 72.5456 33.3054ZM72.7217 34.7027C72.7217 34.7027 72.7217 34.7027 72.7217 34.704L72.7217 34.7027Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.4829,
    y: 36,
    width: 2.02667,
    height: 4.02669,
    transform: "rotate(180 73.4829 36)",
    fill: "url(#pattern26)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 34,
    width: 2,
    height: 1
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0461 34.0507C18.0493 34.1481 18.0524 34.2454 18.056 34.344C17.6644 34.4734 17.33 34.5947 17.0466 34.7067C17.1726 34.6174 17.2998 34.5294 17.4258 34.4427C17.6226 34.3107 17.8305 34.1774 18.0461 34.0507Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.0829,
    y: 36.0001,
    width: 3.36,
    height: 2.69336,
    transform: "rotate(180 19.0829 36.0001)",
    fill: "url(#pattern27)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 34,
    width: 4,
    height: 2
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M18.056 34.344C18.0649 34.5867 18.0737 34.8293 18.0836 35.0707C17.456 35.1053 16.5592 35.2867 15.9826 35.9827C15.9977 35.944 16.0138 35.9053 16.031 35.8667C16.1556 35.576 16.4174 35.32 16.6669 35.052C16.7784 34.9427 16.8925 34.828 17.0185 34.7267C17.0278 34.72 17.0373 34.7133 17.0466 34.7067C17.33 34.5947 17.6644 34.4733 18.056 34.344Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.0829,
    y: 37.2,
    width: 4.02667,
    height: 3.89336,
    transform: "rotate(180 19.0829 37.2)",
    fill: "url(#pattern28)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 35,
    width: 4,
    height: 2
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0836 35.0707C18.1056 35.6347 18.1305 36.1934 18.1576 36.7494C18.0513 36.7494 17.9445 36.7494 17.8379 36.7494C17.4571 36.7494 17.0764 36.7494 16.6956 36.7494C16.5483 36.4174 16.3175 36.1494 15.9649 36.0267C15.9707 36.012 15.9769 35.9974 15.9827 35.9827C16.5592 35.2867 17.456 35.1053 18.0836 35.0707Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.0829,
    y: 37.8667,
    width: 4.02667,
    height: 3.89336,
    transform: "rotate(180 19.0829 37.8667)",
    fill: "url(#pattern29)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 36,
    width: 2,
    height: 1
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9649 36.0267C16.3174 36.1494 16.5482 36.4174 16.6956 36.7494C16.3941 36.7494 16.0925 36.7494 15.7909 36.7494C15.8154 36.5094 15.8737 36.2667 15.9649 36.0267Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.7496,
    y: 37.8667,
    width: 2.69333,
    height: 2.69336,
    transform: "rotate(180 17.7496 37.8667)",
    fill: "url(#pattern30)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 37,
    width: 1,
    height: 1
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9634 37.472C58.9404 37.4787 58.917 37.4867 58.8936 37.4934C58.7467 37.5387 58.5999 37.5827 58.5972 37.5827C58.5967 37.5827 58.5994 37.5827 58.6046 37.58L58.6035 37.58L58.591 37.5774L58.8134 37.5107L58.9467 37.4734C58.9524 37.4734 58.9582 37.472 58.9634 37.472Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.0163,
    y: 38.5334,
    width: 2.69333,
    height: 2.02669,
    transform: "rotate(180 60.0163 38.5334)",
    fill: "url(#pattern31)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 135,
    width: 35,
    height: 25
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8821 159.973C61.0879 159.973 62.8821 158.18 62.8821 155.973L62.8821 139.893C62.8821 137.687 61.0879 135.893 58.8821 135.893L32.7279 135.893C30.5223 135.893 28.7279 137.687 28.7279 139.893L28.7279 155.973C28.7279 158.18 30.5223 159.973 32.7279 159.973L58.8821 159.973Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8821 159.973C61.0879 159.973 62.8821 158.18 62.8821 155.973L62.8821 139.893C62.8821 137.687 61.0879 135.893 58.8821 135.893L32.7279 135.893C30.5223 135.893 28.7279 137.687 28.7279 139.893L28.7279 155.973C28.7279 158.18 30.5223 159.973 32.7279 159.973L58.8821 159.973Z",
    fill: "url(#paint21_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 137,
    width: 32,
    height: 22
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7279 158.64L58.8822 158.64C60.3546 158.64 61.5488 157.447 61.5488 155.973L61.5488 139.893C61.5488 138.42 60.3546 137.227 58.8822 137.227L32.7279 137.227C31.2551 137.227 30.0612 138.42 30.0612 139.893L30.0612 155.973C30.0612 157.447 31.2551 158.64 32.7279 158.64Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_1_22238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7279 158.64L58.8822 158.64C60.3546 158.64 61.5488 157.447 61.5488 155.973L61.5488 139.893C61.5488 138.42 60.3546 137.227 58.8822 137.227L32.7279 137.227C31.2551 137.227 30.0612 138.42 30.0612 139.893L30.0612 155.973C30.0612 157.447 31.2551 158.64 32.7279 158.64Z",
    fill: "url(#paint22_linear_1_22238)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 1,
    width: 15,
    height: 34
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3092 1.14136C31.5415 1.57202 31.7701 2.00405 31.9951 2.43472C32.0712 2.58538 32.1472 2.73603 32.2227 2.88537C30.5983 2.88937 28.1961 3.03203 25.6775 3.61203L25.7259 3.57603C25.7259 3.57603 26.1529 3.15737 25.4243 3.0867C25.3884 3.08404 25.3456 3.08136 25.2956 3.0787C25.5893 2.7307 25.8893 2.38402 26.1941 2.03869C27.9191 1.62536 29.6608 1.32936 31.3092 1.14136ZM18.0237 33.36C18.1024 33.564 18.1775 33.756 18.2472 33.9347C18.1795 33.972 18.1123 34.0107 18.0461 34.0507C18.0384 33.82 18.0305 33.5907 18.0237 33.36Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.0829,
    y: 35.3333,
    width: 16.0267,
    height: 35.36,
    transform: "rotate(180 33.0829 35.3333)",
    fill: "url(#pattern32)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 3,
    width: 2,
    height: 1
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2956 3.07874C25.3456 3.0814 25.3884 3.08408 25.4243 3.08674C26.1529 3.15741 25.7259 3.57607 25.7259 3.57607L25.6775 3.61207C25.3332 3.69207 24.9868 3.78007 24.6399 3.87607C24.8545 3.60807 25.0732 3.34274 25.2956 3.07874Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.3496,
    y: 4.66675,
    width: 3.89333,
    height: 2.69336,
    transform: "rotate(180 27.3496 4.66675)",
    fill: "url(#pattern33)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 2,
    width: 17,
    height: 32
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2226 2.88538C32.5321 3.50138 32.8368 4.11739 33.1384 4.73206C32.4389 5.92539 31.3212 7.88406 30.1832 10.1027C28.5274 11.8921 27.0169 14.236 26.7472 17.688C26.3722 18.5974 26.0092 19.568 25.6737 20.58C25.7201 21.484 25.756 22.24 25.757 22.916C23.9248 23.32 22.054 23.7827 20.1409 24.3054C20.0128 24.34 19.8852 24.376 19.757 24.4107L19.7518 24.7134C19.707 27.4774 19.4873 31.3907 19.3649 33.4094C19.3384 33.4214 19.3122 33.4334 19.2862 33.4454C18.9534 33.5907 18.6316 33.7427 18.3222 33.8934C18.2972 33.9067 18.2722 33.9201 18.2472 33.9347C18.1774 33.7561 18.1024 33.564 18.0237 33.36C18.007 32.8107 17.9925 32.2574 17.9794 31.7027C17.955 30.6161 17.9373 29.5187 17.9269 28.4067C17.8982 26.7974 17.8846 24.9907 17.9941 23.2107C18.1034 21.4307 18.3378 19.6761 18.7217 18.1654C19.1284 16.9467 19.5493 15.78 19.9774 14.6854C20.3461 10.176 22.2144 6.90003 24.6398 3.87603C24.9868 3.78003 25.3332 3.69204 25.6774 3.61204C28.1961 3.03204 30.5982 2.88938 32.2226 2.88538Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.4162,
    y: 34.6667,
    width: 17.36,
    height: 32.6933,
    transform: "rotate(180 34.4162 34.6667)",
    fill: "url(#pattern34)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 4,
    width: 5,
    height: 7
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1384 4.73206C33.2878 5.03739 33.4362 5.34137 33.5836 5.6467C33.7341 5.9587 33.8827 6.27071 34.0327 6.58271C33.8404 6.72271 33.6488 6.86269 33.4571 7.00403C32.5368 7.89469 31.3253 8.86673 30.1832 10.1027C31.3212 7.88406 32.4389 5.92539 33.1384 4.73206Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.0829,
    y: 11.0667,
    width: 5.89333,
    height: 7.22669,
    transform: "rotate(180 35.0829 11.0667)",
    fill: "url(#pattern35)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 22,
    width: 7,
    height: 12
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7571 22.916C25.7571 22.9613 25.7571 23.0053 25.7571 23.0493C24.8723 23.3427 23.9967 23.6574 23.1327 23.9907C22.1899 24.224 21.2393 24.4707 20.28 24.732C20.2227 27.5054 20.0259 31.252 20.0035 33.1467C19.7926 33.2253 19.5779 33.3133 19.365 33.4093C19.4874 31.3907 19.7071 27.4773 19.7519 24.7133L19.7571 24.4107C19.8852 24.376 20.0128 24.34 20.1409 24.3053C22.054 23.7827 23.9248 23.32 25.7571 22.916Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.6829,
    y: 34.6667,
    width: 8.42667,
    height: 12.96,
    transform: "rotate(180 26.6829 34.6667)",
    fill: "url(#pattern36)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 23,
    width: 6,
    height: 11
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1327 23.9907C22.6988 24.1587 22.2685 24.3307 21.8404 24.508C21.9717 24.816 22.1013 25.1241 22.23 25.4321C23.3008 24.9894 24.3889 24.5774 25.4941 24.1974C25.5363 24.4134 25.5789 24.6294 25.6212 24.8454C25.4685 25.76 25.1603 26.648 24.6128 27.776C24.3723 28.9814 24.1508 30.1667 24.0545 31.3014C24.0352 31.5281 24.0212 31.7507 24.0128 31.972C23.7841 32.024 23.5571 32.0747 23.3237 32.1321C22.9868 32.2241 22.6488 32.3147 22.3117 32.404C21.6581 32.5734 20.9545 32.8094 20.2889 33.0467C20.1945 33.0774 20.0994 33.1107 20.0035 33.1467C20.0259 31.252 20.2227 27.5054 20.28 24.7321C21.2393 24.4707 22.1899 24.2241 23.1327 23.9907Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.6829,
    y: 34.0001,
    width: 7.76,
    height: 10.96,
    transform: "rotate(180 26.6829 34.0001)",
    fill: "url(#pattern37)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 24,
    width: 1,
    height: 1
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7117 24.1227C25.7024 24.228 25.692 24.332 25.6795 24.4347C25.6633 24.5734 25.6441 24.7093 25.6212 24.8453C25.5789 24.6293 25.5363 24.4134 25.4941 24.1974C25.5665 24.172 25.6393 24.1467 25.7117 24.1227Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.6829,
    y: 25.7333,
    width: 2.02667,
    height: 2.69336,
    transform: "rotate(180 26.6829 25.7333)",
    fill: "url(#pattern38)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 36,
    width: 3,
    height: 7
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3503 36.7494C18.5951 36.7494 18.8399 36.7494 19.0847 36.7494C18.7889 38.0734 18.3732 40.1134 18.0379 42.46C17.9753 42.2774 17.9144 42.092 17.8545 41.904C18.0789 40.6733 18.1925 39.388 18.2284 38.068C18.2117 37.7867 18.1967 37.504 18.1816 37.22C18.2409 37.0574 18.2972 36.9 18.3503 36.7494Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.2829,
    y: 43.7334,
    width: 3.22667,
    height: 7.89336,
    transform: "rotate(180 20.2829 43.7334)",
    fill: "url(#pattern39)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 36,
    width: 9,
    height: 9
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0847 36.7494C21.0488 36.7494 23.0123 36.7494 24.9764 36.7494C25.0789 36.952 25.192 37.152 25.3169 37.3507C25.7056 38.4267 26.13 39.3214 26.5889 40.0587C26.7071 40.2374 26.8227 40.412 26.9393 40.5827C26.6373 40.8907 26.3357 41.1867 26.0341 41.4694C25.0019 42.3507 23.968 43.092 22.9269 43.6894C21.8967 44.1294 20.854 44.4267 19.8003 44.5747C19.5723 44.588 19.3436 44.5934 19.1149 44.5934C19.0461 44.5934 18.9779 44.5934 18.9103 44.592C18.7841 44.324 18.6565 44.0454 18.5289 43.76C18.3556 43.3427 18.1925 42.9107 18.0379 42.46C18.3732 40.1134 18.7889 38.0734 19.0847 36.7494Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.0162,
    y: 45.6,
    width: 10.96,
    height: 9.76003,
    transform: "rotate(180 28.0162 45.6)",
    fill: "url(#pattern40)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 36,
    width: 1,
    height: 2
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1576 36.7494C18.2222 36.7494 18.2862 36.7494 18.3502 36.7494C18.2972 36.9 18.2409 37.0574 18.1816 37.22C18.1732 37.064 18.1654 36.9067 18.1576 36.7494Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.7496,
    y: 38.5334,
    width: 2.69333,
    height: 2.69336,
    transform: "rotate(180 19.7496 38.5334)",
    fill: "url(#pattern41)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 23,
    width: 5,
    height: 3
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7571 23.0494C25.7551 23.4267 25.7415 23.7814 25.7117 24.1227C25.6393 24.1467 25.5665 24.1721 25.4941 24.1974C24.3889 24.5774 23.3008 24.9894 22.23 25.4321C22.1013 25.1241 21.9717 24.816 21.8404 24.508C22.2685 24.3307 22.6988 24.1587 23.1327 23.9907C23.9967 23.6574 24.8723 23.3427 25.7571 23.0494Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.6829,
    y: 26.4,
    width: 5.89333,
    height: 4.69336,
    transform: "rotate(180 26.6829 26.4)",
    fill: "url(#pattern42)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 33,
    width: 1,
    height: 2
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2472 33.9347C18.2893 34.0427 18.3294 34.1453 18.368 34.2427C18.2608 34.2773 18.156 34.3107 18.056 34.344C18.0524 34.2453 18.0493 34.148 18.0461 34.0507C18.1122 34.0107 18.1794 33.972 18.2472 33.9347Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.7496,
    y: 35.3334,
    width: 2.69333,
    height: 2.69336,
    transform: "rotate(180 19.7496 35.3334)",
    fill: "url(#pattern43)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 33,
    width: 2,
    height: 2
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3649 33.4094C19.3524 33.612 19.3409 33.796 19.3311 33.9574C18.9805 34.0547 18.6608 34.1507 18.368 34.2427C18.3295 34.1454 18.2893 34.0427 18.2472 33.9347C18.2723 33.9201 18.2972 33.9067 18.3223 33.8934C18.6316 33.7427 18.9535 33.5907 19.2863 33.4454C19.3123 33.4334 19.3384 33.4214 19.3649 33.4094Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.2829,
    y: 35.3334,
    width: 3.22667,
    height: 2.69336,
    transform: "rotate(180 20.2829 35.3334)",
    fill: "url(#pattern44)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 33,
    width: 7,
    height: 4
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0967 33.7587C24.1165 33.8947 24.1404 34.0294 24.1675 34.1627C21.754 34.5641 20.0701 34.9361 19.4639 35.1574C19.4639 35.1574 19.3087 35.7481 19.0847 36.7494C18.8399 36.7494 18.5951 36.7494 18.3503 36.7494C18.6117 36.0041 18.7868 35.4161 18.8045 35.0921C18.8045 35.0921 18.616 35.0641 18.3279 35.0641C18.2524 35.0641 18.1707 35.0654 18.0836 35.0707C18.0737 34.8294 18.0649 34.5867 18.056 34.344C18.156 34.3107 18.2608 34.2774 18.368 34.2427C18.6608 34.1507 18.9805 34.0547 19.3311 33.9574C19.3013 34.4334 19.2827 34.7161 19.2816 34.7294C19.2909 34.6761 21.2149 34.2721 24.0967 33.7587Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.4829,
    y: 37.8667,
    width: 8.42667,
    height: 5.22669,
    transform: "rotate(180 25.4829 37.8667)",
    fill: "url(#pattern45)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 34,
    width: 6,
    height: 3
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1674 34.1627C24.192 34.2827 24.2196 34.4013 24.2502 34.5187C24.3769 35.276 24.6065 36.0213 24.9764 36.7493C23.0122 36.7493 21.0488 36.7493 19.0846 36.7493C19.3086 35.748 19.4638 35.1574 19.4638 35.1574C20.0701 34.936 21.754 34.564 24.1674 34.1627Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.1496,
    y: 37.8667,
    width: 7.89333,
    height: 4.56003,
    transform: "rotate(180 26.1496 37.8667)",
    fill: "url(#pattern46)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 35,
    width: 1,
    height: 2
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3278 35.0641C18.616 35.0641 18.8045 35.0921 18.8045 35.0921C18.7868 35.4161 18.6117 36.004 18.3502 36.7494C18.2862 36.7494 18.2222 36.7494 18.1576 36.7494C18.1305 36.1934 18.1056 35.6347 18.0836 35.0707C18.1706 35.0654 18.2524 35.0641 18.3278 35.0641Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.7496,
    y: 37.8667,
    width: 2.69333,
    height: 3.89336,
    transform: "rotate(180 19.7496 37.8667)",
    fill: "url(#pattern47)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 33,
    width: 6,
    height: 2
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0035 33.1467C19.9945 33.8921 20.0123 34.3507 20.0769 34.3507C20.0779 34.3507 20.0789 34.3507 20.0805 34.3507C21.3827 33.9881 22.7056 33.6547 24.0472 33.3494C24.0603 33.4867 24.0769 33.6241 24.0967 33.7587C21.2149 34.2721 19.2909 34.6761 19.2816 34.7294C19.2827 34.7161 19.3013 34.4334 19.3311 33.9574C19.3409 33.7961 19.3524 33.6121 19.3649 33.4094C19.5779 33.3134 19.7925 33.2254 20.0035 33.1467Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.8163,
    y: 36.0001,
    width: 6.56,
    height: 4.02669,
    transform: "rotate(180 24.8163 36.0001)",
    fill: "url(#pattern48)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 31,
    width: 5,
    height: 4
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0128 31.972C23.9956 32.4427 24.0045 32.9027 24.0472 33.3494C22.7056 33.6547 21.3826 33.9881 20.0805 34.3507C20.0789 34.3507 20.0778 34.3507 20.0769 34.3507C20.0122 34.3507 19.9945 33.8921 20.0035 33.1467C20.0993 33.1107 20.1945 33.0774 20.2889 33.0467C20.9545 32.8094 21.6581 32.5734 22.3117 32.404C22.6488 32.3147 22.9868 32.2241 23.3237 32.1321C23.5571 32.0747 23.7841 32.024 24.0128 31.972Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.8162,
    y: 35.3334,
    width: 5.89333,
    height: 4.56003,
    transform: "rotate(180 24.8162 35.3334)",
    fill: "url(#pattern49)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 1,
    width: 8,
    height: 3
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3134 1.03998C60.8415 1.17865 62.4748 1.41199 64.117 1.74932C64.6462 2.34399 65.1623 2.93865 65.6571 3.54131C63.2019 3.01331 60.8868 2.88532 59.329 2.88532L58.3451 2.88532C58.4212 2.73599 58.4967 2.58534 58.5727 2.43467C58.8155 1.97067 59.0623 1.50531 59.3134 1.03998Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.4163,
    y: 4.66669,
    width: 9.09333,
    height: 4.69336,
    transform: "rotate(180 66.4163 4.66669)",
    fill: "url(#pattern50)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 2,
    width: 16,
    height: 32
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3451 2.88532L59.329 2.88532C60.8869 2.88532 63.2019 3.01331 65.6571 3.54131C68.2134 6.65997 70.2077 10.0093 70.5905 14.6853C71.0186 15.78 71.4394 16.9467 71.8462 18.1653C72.2306 19.676 72.465 21.4306 72.5738 23.2106C72.6833 24.9906 72.6697 26.7973 72.641 28.4066C72.6306 29.5186 72.6129 30.616 72.5885 31.7027C72.5775 32.172 72.5655 32.6387 72.5519 33.1027C72.5415 33.0987 72.5306 33.0947 72.5202 33.0907C72.2385 30.764 71.7759 26.6373 71.9066 25.6627L71.9451 25.3613C71.8175 25.3173 71.6899 25.272 71.5623 25.228C69.3577 24.4613 67.1629 23.7933 64.9713 23.2213C67.6113 20.1227 59.1675 5.86797 57.9025 3.7733C58.0494 3.4773 58.1967 3.18132 58.3451 2.88532Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.483,
    y: 34,
    width: 16.8267,
    height: 32.0267,
    transform: "rotate(180 73.483 34)",
    fill: "url(#pattern51)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 3,
    width: 10,
    height: 21
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9024 3.77338C59.1675 5.86804 67.6112 20.1227 64.9712 23.2214C64.918 23.2081 64.8649 23.1934 64.8123 23.18C64.8029 22.4374 64.842 21.604 64.8945 20.58C64.5592 19.568 64.1956 18.5974 63.8207 17.6881C63.3649 11.8534 59.3649 9.18671 57.1112 7.00404C56.9191 6.86271 56.7279 6.72405 56.5363 6.58405L56.5363 6.58138C56.6857 6.26938 56.8341 5.95738 56.9841 5.64672C57.2868 5.02138 57.5925 4.39738 57.9024 3.77338Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 68.2829,
    y: 24.4,
    width: 12.8267,
    height: 21.8933,
    transform: "rotate(180 68.2829 24.4)",
    fill: "url(#pattern52)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 23,
    width: 9,
    height: 11
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8123 23.18C64.8649 23.1933 64.918 23.208 64.9712 23.2213C67.1628 23.7933 69.3576 24.4613 71.5623 25.228C71.6899 25.272 71.8175 25.3173 71.9451 25.3613L71.9065 25.6627C71.7759 26.6373 72.2384 30.764 72.5201 33.0907C72.2983 33.0107 72.0759 32.932 71.8524 32.8573C71.5409 30.384 71.33 28.472 71.3832 25.6387C69.1841 24.8787 67.0008 24.212 64.8248 23.6413C64.8185 23.4907 64.8139 23.3373 64.8123 23.18Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.4829,
    y: 34,
    width: 9.76,
    height: 11.6267,
    transform: "rotate(180 73.4829 34)",
    fill: "url(#pattern53)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 23,
    width: 8,
    height: 10
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8248 23.6414C67.0008 24.212 69.1842 24.8787 71.3832 25.6387C71.33 28.472 71.541 30.384 71.8524 32.8574C70.739 32.484 69.6112 32.184 68.5332 31.9454C67.8576 31.7934 67.191 31.6574 66.5316 31.5347C66.5259 31.4574 66.5202 31.3801 66.5134 31.3014C66.417 30.1667 66.1956 28.9814 65.9551 27.776C65.4775 26.792 65.1816 25.9894 65.0123 25.1934C65.0691 24.904 65.1259 24.616 65.1827 24.3267C65.0775 24.296 64.9723 24.2667 64.867 24.2361C64.8478 24.0427 64.8342 23.8454 64.8248 23.6414Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8163,
    y: 34.0001,
    width: 9.09333,
    height: 11.6267,
    transform: "rotate(180 72.8163 34.0001)",
    fill: "url(#pattern54)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 24,
    width: 2,
    height: 2
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8669 24.236C64.9723 24.2667 65.0775 24.296 65.1827 24.3267C65.1259 24.616 65.0691 24.904 65.0123 25.1933C64.9592 24.9413 64.9185 24.6907 64.8884 24.4347C64.8805 24.3694 64.8732 24.3027 64.8669 24.236Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.4163,
    y: 26.4,
    width: 2.69333,
    height: 3.36003,
    transform: "rotate(180 66.4163 26.4)",
    fill: "url(#pattern55)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 36,
    width: 1,
    height: 1
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4311 36.3134C72.4275 36.392 72.4238 36.4694 72.4202 36.548C72.4019 36.468 72.3847 36.392 72.368 36.3187C72.389 36.3174 72.4103 36.3147 72.4311 36.3134Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.4829,
    y: 37.8667,
    width: 2.02667,
    height: 2.69336,
    transform: "rotate(180 73.4829 37.8667)",
    fill: "url(#pattern56)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 36,
    width: 10,
    height: 9
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M72.368 36.3187C72.3847 36.392 72.4019 36.468 72.4202 36.548C72.3956 37.0574 72.3686 37.564 72.3399 38.068C72.3754 39.388 72.489 40.6733 72.7134 41.904C72.506 42.5587 72.2822 43.1734 72.039 43.76C71.9112 44.0454 71.7836 44.324 71.6582 44.592C71.5899 44.5934 71.5218 44.5934 71.453 44.5934C71.2243 44.5934 70.9956 44.588 70.7675 44.5747C69.7139 44.4267 68.6712 44.1294 67.641 43.6894C66.6003 43.092 65.5666 42.3507 64.5336 41.4694C64.2322 41.1867 63.9306 40.8907 63.629 40.5827C63.7451 40.412 63.8612 40.2374 63.979 40.0587C64.4379 39.3214 64.8623 38.4267 65.2508 37.3507C65.3431 37.204 65.4284 37.0574 65.5082 36.9094C66.1795 36.852 66.8508 36.7947 67.5218 36.7373C69.1374 36.5973 70.7524 36.4587 72.368 36.3187Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.483,
    y: 45.6,
    width: 11.0933,
    height: 10.4267,
    transform: "rotate(180 73.483 45.6)",
    fill: "url(#pattern57)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 33,
    width: 1,
    height: 1
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5201 33.0907C72.5305 33.0947 72.5415 33.0987 72.5519 33.1027C72.5499 33.1707 72.5483 33.2373 72.5456 33.3053C72.5373 33.236 72.5289 33.164 72.5201 33.0907Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.4829,
    y: 34,
    width: 2.02667,
    height: 2.02669,
    transform: "rotate(180 73.4829 34)",
    fill: "url(#pattern58)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 34,
    width: 1,
    height: 1
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4513 34.6201C72.4691 34.6241 72.4852 34.6281 72.5013 34.6321C72.5008 34.6481 72.5003 34.6627 72.4999 34.6787C72.4775 34.672 72.4551 34.6654 72.4327 34.6574C72.4389 34.6454 72.4451 34.6334 72.4513 34.6201Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.4829,
    y: 36.0001,
    width: 2.02667,
    height: 2.69336,
    transform: "rotate(180 73.4829 36.0001)",
    fill: "url(#pattern59)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 71,
    y: 34,
    width: 2,
    height: 1
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8842 34.4947C72.1218 34.5441 72.3123 34.5867 72.4514 34.62C72.4451 34.6334 72.439 34.6454 72.4327 34.6574C72.2546 34.604 72.0718 34.5494 71.8842 34.4947Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.4829,
    y: 36.0001,
    width: 2.69333,
    height: 2.69336,
    transform: "rotate(180 73.4829 36.0001)",
    fill: "url(#pattern60)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 33,
    width: 7,
    height: 4
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5045 33.508C68.9112 33.912 70.8445 34.2747 71.8841 34.4947C72.0717 34.5493 72.2545 34.604 72.4327 34.6573C72.4551 34.6653 72.4775 34.672 72.4999 34.6787C72.4789 35.2267 72.4565 35.772 72.4311 36.3133C72.4103 36.3147 72.3889 36.3173 72.368 36.3187C72.2305 35.7187 72.1436 35.376 72.1436 35.376C71.4581 35.1267 69.3732 34.652 66.4029 34.1507C66.4456 33.9387 66.4789 33.7253 66.5045 33.508Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.4829,
    y: 37.3333,
    width: 7.89333,
    height: 4.69336,
    transform: "rotate(180 73.4829 37.3333)",
    fill: "url(#pattern61)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 34,
    width: 8,
    height: 3
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M66.403 34.1507C69.3732 34.652 71.4582 35.1267 72.1436 35.376C72.1436 35.376 72.2306 35.7187 72.368 36.3187C70.7524 36.4587 69.1374 36.5973 67.5218 36.7373C66.8508 36.7947 66.1795 36.852 65.5082 36.9094C65.927 36.1307 66.1822 35.3307 66.3175 34.5187C66.3494 34.3974 66.3779 34.2747 66.403 34.1507Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.483,
    y: 37.8667,
    width: 9.09333,
    height: 4.56003,
    transform: "rotate(180 73.483 37.8667)",
    fill: "url(#pattern62)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 32,
    width: 7,
    height: 3
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8524 32.8574C72.0759 32.932 72.2983 33.0107 72.5202 33.0907C72.529 33.164 72.5374 33.236 72.5457 33.3053C72.5327 33.7493 72.5175 34.192 72.5014 34.632C72.4853 34.628 72.4691 34.624 72.4514 34.62C72.3123 34.5867 72.1218 34.544 71.8842 34.4947C70.8446 34.2747 68.9113 33.912 66.5046 33.508C66.527 33.3107 66.5426 33.1107 66.5519 32.9093C68.4123 33.3 70.2405 33.7467 72.029 34.252C71.9675 33.7627 71.9082 33.3014 71.8524 32.8574Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.483,
    y: 36,
    width: 7.89333,
    height: 4.02669,
    transform: "rotate(180 73.483 36)",
    fill: "url(#pattern63)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_1_22238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 31,
    width: 7,
    height: 4
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5316 31.5347C67.1909 31.6574 67.8576 31.7934 68.5332 31.9454C69.6112 32.184 70.7389 32.4841 71.8524 32.8574C71.9081 33.3014 71.9675 33.7627 72.0289 34.252C70.2404 33.7467 68.4123 33.3 66.5519 32.9094C66.5732 32.4614 66.5639 32.0027 66.5316 31.5347Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_1_22238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.8163,
    y: 35.3334,
    width: 7.22667,
    height: 4.56003,
    transform: "rotate(180 72.8163 35.3334)",
    fill: "url(#pattern64)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_22238",
    transform: "scale(0.333333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_22238",
    transform: "scale(0.125 0.0384615)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_1_22238",
    transform: "scale(0.125 0.0384615)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_1_22238",
    transform: "scale(0.125 0.0384615)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_1_22238",
    transform: "scale(0.125 0.0384615)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5_1_22238",
    transform: "scale(0.015625 0.0555556)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6_1_22238",
    transform: "scale(0.111111 0.00657895)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7_1_22238",
    transform: "scale(0.111111 0.00657895)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern8",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image8_1_22238",
    transform: "scale(0.0120482 0.1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern9",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image9_1_22238",
    transform: "scale(0.0526316 0.0555556)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern10",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image10_1_22238",
    transform: "scale(0.0416667 0.0555556)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern11",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image11_1_22238",
    transform: "scale(0.0120482 0.0909091)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern12",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image12_1_22238",
    transform: "scale(0.0526316 0.0384615)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern13",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image13_1_22238",
    transform: "scale(0.0416667 0.0384615)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern14",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image14_1_22238",
    transform: "scale(0.0416667 0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern15",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image15_1_22238",
    transform: "scale(0.0142857 0.142857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern16",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image16_1_22238",
    transform: "scale(0.0144928 0.0909091)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern17",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image17_1_22238",
    transform: "scale(0.0142857 0.142857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern18",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image18_1_22238",
    transform: "scale(0.0142857 0.142857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern19",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image19_1_22238",
    transform: "scale(0.0166667 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern20",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image20_1_22238",
    transform: "scale(0.0163934 0.142857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern21",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image21_1_22238",
    transform: "scale(0.1 0.125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern22",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image22_1_22238",
    transform: "scale(0.25 0.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern23",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image23_1_22238",
    transform: "scale(0.125 0.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern24",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image24_1_22238",
    transform: "scale(0.142857 0.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern25",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image25_1_22238",
    transform: "scale(0.25 0.333333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern26",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image26_1_22238",
    transform: "scale(0.333333 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern27",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image27_1_22238",
    transform: "scale(0.2 0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern28",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image28_1_22238",
    transform: "scale(0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern29",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image29_1_22238",
    transform: "scale(0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern30",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image30_1_22238",
    transform: "scale(0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern31",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image31_1_22238",
    transform: "scale(0.25 0.333333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern32",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image32_1_22238",
    transform: "scale(0.04 0.0181818)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern33",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image33_1_22238",
    transform: "scale(0.166667 0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern34",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image34_1_22238",
    transform: "scale(0.037037 0.0196078)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern35",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image35_1_22238",
    transform: "scale(0.111111 0.0909091)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern36",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image36_1_22238",
    transform: "scale(0.0769231 0.05)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern37",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image37_1_22238",
    transform: "scale(0.0833333 0.0588235)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern38",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image38_1_22238",
    transform: "scale(0.333333 0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern39",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image39_1_22238",
    transform: "scale(0.2 0.0833333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern40",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image40_1_22238",
    transform: "scale(0.0588235 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern41",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image41_1_22238",
    transform: "scale(0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern42",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image42_1_22238",
    transform: "scale(0.111111 0.142857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern43",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image43_1_22238",
    transform: "scale(0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern44",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image44_1_22238",
    transform: "scale(0.2 0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern45",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image45_1_22238",
    transform: "scale(0.0769231 0.125)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern46",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image46_1_22238",
    transform: "scale(0.0833333 0.142857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern47",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image47_1_22238",
    transform: "scale(0.25 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern48",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image48_1_22238",
    transform: "scale(0.1 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern49",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image49_1_22238",
    transform: "scale(0.111111 0.142857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern50",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image50_1_22238",
    transform: "scale(0.0714286 0.142857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern51",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image51_1_22238",
    transform: "scale(0.0384615 0.02)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern52",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image52_1_22238",
    transform: "scale(0.05 0.0294118)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern53",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image53_1_22238",
    transform: "scale(0.0666667 0.0555556)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern54",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image54_1_22238",
    transform: "scale(0.0714286 0.0555556)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern55",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image55_1_22238",
    transform: "scale(0.25 0.2)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern56",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image56_1_22238",
    transform: "scale(0.333333 0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern57",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image57_1_22238",
    transform: "scale(0.0588235 0.0625)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern58",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image58_1_22238",
    transform: "scale(0.333333)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern59",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image59_1_22238",
    transform: "scale(0.333333 0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern60",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image60_1_22238",
    transform: "scale(0.25)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern61",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image61_1_22238",
    transform: "scale(0.0833333 0.142857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern62",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image62_1_22238",
    transform: "scale(0.0714286 0.142857)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern63",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image63_1_22238",
    transform: "scale(0.0833333 0.166667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern64",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image64_1_22238",
    transform: "scale(0.0909091 0.142857)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_22238",
    x1: 29.1176,
    y1: 94.1054,
    x2: -0.295492,
    y2: 93.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_22238",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8052 22.14) rotate(180) scale(27.6095 27.154)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ABAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_22238",
    x1: 25.8501,
    y1: 6.10007,
    x2: 17.8306,
    y2: 6.10007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_22238",
    x1: 70.3234,
    y1: 6.10002,
    x2: 66.2087,
    y2: 6.10002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1_22238",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6372 24.304) rotate(180) scale(26.3691 19.9983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D6D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_22238",
    x1: 60.05,
    y1: 2.56805,
    x2: 42.0409,
    y2: 20.8777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1_22238",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8045 48.048) rotate(180) scale(25.6412 25.6412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D6D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_22238",
    x1: 63.2655,
    y1: 19.956,
    x2: 34.8421,
    y2: 68.6036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_22238",
    x1: 19.0245,
    y1: 36.024,
    x2: 10.7243,
    y2: 43.9294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_22238",
    x1: 16.8631,
    y1: 38.5387,
    x2: 6.7749,
    y2: 37.2563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_22238",
    x1: 16.7935,
    y1: 39.788,
    x2: 6.61796,
    y2: 38.4946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_22238",
    x1: 72.5988,
    y1: 36.0227,
    x2: 80.8991,
    y2: 43.9281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_22238",
    x1: 74.7603,
    y1: 38.536,
    x2: 84.8485,
    y2: 37.2537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_22238",
    x1: 74.8293,
    y1: 39.788,
    x2: 85.0047,
    y2: 38.4946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_22238",
    x1: 57.7459,
    y1: 3.08803,
    x2: 33.8651,
    y2: 3.08803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0D0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_22238",
    x1: 18.4224,
    y1: 43.4093,
    x2: 3.39817,
    y2: 72.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_22238",
    x1: 80.4959,
    y1: 42.5307,
    x2: 63.3251,
    y2: 75.7761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_22238",
    x1: 83.1262,
    y1: 48.7747,
    x2: 72.7665,
    y2: 56.5984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_22238",
    x1: 72.0291,
    y1: 27.7187,
    x2: 20.0011,
    y2: 27.7187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0D0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_22238",
    x1: 79.5325,
    y1: 126.611,
    x2: -12.2131,
    y2: 126.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_22238",
    x1: 79.5324,
    y1: 126.611,
    x2: -12.2132,
    y2: 126.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_22238",
    x1: 62.882,
    y1: 147.933,
    x2: 28.7277,
    y2: 147.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_22238",
    x1: 61.5487,
    y1: 147.933,
    x2: 30.0611,
    y2: 147.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_22238",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAABtJREFUCJljXLdu3X8WFhYGFhYWBiYGJIDCAQBx0wMnRXwm8gAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_22238",
    width: 8,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAaCAYAAACKER0bAAAABHNCSVQICAgIfAhkiAAAAJNJREFUKJGFklEKBDEIQ6N4/+st7B7G/Rht0CojFNrxJU07lc/v63BHFmdPKQBA5BkAJEaWFTwguB9Iu6I7appuoLIzg9r6p51LPW4FpI/R0EE94EFb+3KBSwbGPBd1G+U9SFV0I6NcYvstw3DEOUNz3DPEwggvGe7tq6P2n9xBGyKWk2uRD8+mATe4AARfgFcH4A9HCxcmUXdjjAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_1_22238",
    width: 8,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAaCAYAAACKER0bAAAABHNCSVQICAgIfAhkiAAAAPdJREFUKJFt0ktyBSEMQ9Er2QtLsv81SRnQ79NVPQQOhYWtn7/ftpAGgLY0pQ0trGxomZoWQtCIVjRlbZ9b7SNcWzSi6iNcyWg4bz7A9ZimwDNcI7AI/UCXAo1YzUCCyx22yGUtwQxpH+GJmWLxCA94VX6DgfTEREF9VR4asEwHdixSUwoC8h0XFgsjSElL3YMvuCOTQn0VVt3gymKAxgSo7nDtE03OI1zbqKG9w8QUWCSEkUANyVCKndOsuQYmLcLMFTEZ0FWkKnTNwAvaBWBBoCIJAiO9IS0LcL4Q5LP6hisE5+8eoRGcJLqOv6FOd997OkifDf4BaGMGPwQ5IY4AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_1_22238",
    width: 8,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAaCAYAAACKER0bAAAABHNCSVQICAgIfAhkiAAAAJFJREFUKJF9kUEWhDAMQin3v+G8mavgxrRIMrrwacIvoOvz+wprYQHAffeLAADVq7pA90J/RIRqJFvJBEcBSM2EjY4HdvqZh0nniUw6T+QbDUXNKc+uOdFmYe0jD/dacxtWacWi1CzaUc9zLGC05dkWTyv7kg96EHGij0XUnPJQE22zbhHiZpF5+Eafn1WDIc8Foe2pJxHr1JUAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4_1_22238",
    width: 8,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAaCAYAAACKER0bAAAABHNCSVQICAgIfAhkiAAAAQdJREFUKJFVklGOHFEMAsveHDHJ/U9C5QO/2U1Lo1ZrMGDw/P77x9nla7+YgZnhPQobBSUG/R8wA6vSXxBJwsx8gCsSxRQYCyrDsOQAgAlq9el7k3p40ypJGZlhQ/XzppWQA4VFMdQonSalj3aLkMpEusutHVlPr1Ye8Jtxz//56B8hn7UrkZueGjM3ZtgmGBByHn4y/oqwSkY2ISyD7DbNhTN5tMOPsF6SIpjrofQNIixeas6nUW1IUbahieT25yLPA/RQKpUfUh3cecfiUQcwPPPb7+6OaYrnoUmm0eT6aN2XKLDmu6Q2yEVd6V/OTbY5nIDbtV/dXLVP6tMFr826Ot13mz3ifzSWsjPGkJVnAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image5_1_22238",
    width: 64,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAASCAYAAADrL9giAAAABHNCSVQICAgIfAhkiAAAAItJREFUWIXtkEEOAjEMxAw/RfD/J4w5tFuExH0OxFJVbRMl3rk9Xk9FjETBENe3ioYEJOdt9e16QgTNOnuOShJQEgmr91ePZx7k1K99OTvXrn3ncmU7+rkTzj8lCF+1z6xw58+ZANoCbSaAtkCbCaAt0GYCaAu0mQDaAm0mgLZAmwmgLdBmAmgLtHkDVESvVljOeQsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image6_1_22238",
    width: 9,
    height: 152,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAACYCAYAAAA2q8P2AAAABHNCSVQICAgIfAhkiAAAAzRJREFUWIWtWFuS2zAMIxXf/2qdaa8Ti/2wSIMg5WQ71c86MgVAfMla/fXntwkMjYd4kiE0YoVZb2SWQMP46F6a0675QteNqmmttiejFgn1BAqh/UxTu300QpqOcvDkj5BwvtXEqCOt3rhjdAatJiHn8WZuTf53zgbJrCBUTZsdFU3Fy1tNKJ6cOjheJZXNNh7/pKmNXZcFbJwzc6cpVj1lgULNGxuwJh44f4SW9ULBYC7RLVLRhFpskxFDBBoXCU5GSNO1oSNowPNTRHRl6Ov1IiMzEdVe+NPORCSHZZvjZVmDllLF5C6pmiqsw8OyFkRmlgwA6qPrAR7oRNfFzofKN/mkCpowNGQ8kCohsabI88b4Fg4v5pzx23d4cLwc1czknDMLD38RZXIB+2gbu67ERfTWlKqkK3N2Ju5MUFPsSuoYrMfMxOaM3hnCy0lAlN+dnNuXqwZvuo23nfI/nea6K3NI3Us4G4BukXXk9xQXwnmet6YnHyXh3OxV7nh+h9SJvQQ3B1BF0xxgVRU8Y1rhiRLqrqXjnjLnlPf7/dBVivAHF6hX8Ae7z9++kXSd6EKnquC6D3Q76jhbnM6sfmjVjwfSljJTRUWWNo+jx3TsAqt8kXjKgKLpgk8TYMRI9HvwPEYmMnMrXETeWHf3C22Y9bmrpLrDia7Btki8oApXFTFLqTP4/VaTqmYLp0MkpuQvxEcXTDM5z1NGjifm0QJi4UztjezfboqIZo6kYwO2HHrRrWN+jHEVgi5fP16W4VRXvdLncXcJSckg+U5MhlBaBBLEs5RUMlz6BrdnpPb5I71EKlkp7L0AHcrNImkKJzZuQIh4jIuEF2cS3VBF903wtOhyAaIgEixoY8fCD6bj5+iZyi9l4ydEqddJzEZE/ITkC8xM5nnWroJ63C1HQF9Ly/b3xcldpfgIqRzp8cPBnenWisXJSD1EdslXXeVwb5uqzDlljHH5aox4bjNTaDMjtv1JU6ncbNlXC4+sSWrCJbr0LwG6AeWwQMV4x0se58LEbG1PBB6H+4ivJlis0TM58rioaOrpGk2lP+06XYvERwUWaxs7XpA1NQtEVmb6SPc7mP8LBuiLhiO/aZ4AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image7_1_22238",
    width: 9,
    height: 152,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAACYCAYAAAA2q8P2AAAABHNCSVQICAgIfAhkiAAAA0JJREFUWIWdWO1u5DAIBJT3f7VKd6/TmPsRGw8wzraHVDXr4OFrwN7Vr79/XKZoPMSTiLuYgLhwufYGF10IntUvLwuOZqeY/EA+KnlVWqZrANYUiKLhi//2SUTE0MzJ5M/M1d1LcN3qAkMNJKxXRbeqQH2SEgnz0VDhiIQIPkZ6mXw6hb+RapbJ/5yno081kaSGzSeGRllQN/6SdBOJ8cqWs8zM+pxqlxSST6otopZxQfuVdIlPBcXdZWBZHF5UToW5xmvGcVMVVaVNEH03SvJcRMYYsaaqYO7AJxodkyvlB0wgmrFokvNjzLK85CiQYvmNdGvx1FomUua2e8qTiIi5by4dW6pOfz6f9Dy8Esc/9h06fJqfG0mrd1NUxVT1SQFByX03Zdw3j05jF0Q1RkroHhjCnX6imyyocKUsLg/fdoTHQ1EXUDE3xlh84mVJSCp6TuY2lyO8v7+z0okqeDrMPGn2qZhuzck8M/Tl6Hh7PaeMgslEukhoCSIN+1HOu4SkL4lsSALT5M55egXpjov0dLSTEyWlwMVplhvSR59m17XCqJRkBvRspWaOFnceQItTvzuDWWFDqZ7B2Xvtjr+a+1Q/A9RjANvxF57bclBl8/oeI/G8t9R8gZk3Rt26BqNnzyc0paqf83TfN1fSYtJwNtXO7eZUgxroT3Icxd3lvu8c3VsH6wnpPFXWS9Jghgq+P1SkdqOLTWtDM8ckLlmIEwfllOeb4jx8kJkrwueSRcyt2+FKaPsiEQjo03aGzyjKJy1KGQlMYFnoEMN0BJKKiOn8SpW1Q9EYK1c7Lcx+EyNfvRMLTtS7npt9LkdCFJgq2EaomJLpBSn3nepOJFF4lIijtYOvRTKGEgVWVcoAnE9XDbeaihQgPJMLZ2XNz6pC67u6wVN05H/4ZLWw5RqSpkr9dQajzNHBs4tE311RN/ec+RPSMovKSam+wLV2bKwEYoSpdmyDCDmAgoSd4xxprZmpipmlguJzmgWVASHuT5vHNCFOJ8fXHE8oKeM4fSvfVffvdGyAJXOs//scLwrV+YR0PDbqLqrE2pry6WQyTd9Pt+idpxdO/exQVLM8L9cf+Nlqtz5jDVvtWMdcQqT69g+Ed253GfR1lwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image8_1_22238",
    width: 83,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAAAKCAYAAADIM2I/AAAABHNCSVQICAgIfAhkiAAAAklJREFUSImtVkty7CAM7Bbk/ndK1XunslEWRqAPk0yqooUNsj6oaYT5+f+fQhWqCgB4ntjz9EbWH+xFZNsDGGMAAEgu/yUHnfnS5kguIntsNmMsO5J4R3zc7CMiK7Z9W+sy2/m2eddZ6F+AaO/7voMPZ2LLZXMAS2d6X6DOEB5vhYL3gJeCnWrdgBnEA85DPSaZAAaY+SxikGve8YaQDE5QjUEBqNs9WwjIwEaLYwWvohLTMjPhdAChQyuAM5+P43fBckgG1daSAvraPJB+7pkpIuiWhLbYCRrIwj76by5ZAdeOyLQTaeU0cz6KDoBSE5QPI00GHWsACA/H3vlyUl6dQnxuZo9NjgWgSAHXjwmgL2b55CviBvhbMXDntOVk3CX6I/7kqjkIhp4r5GOpClVApC2X43G2Gvz6uXU67R6QFZiEUtXSmnzMED+fAjgwTYx51ifoE0XD6jeTXLNnenYCT1PP/q1/RDCQ5ADYfV2luEjxGOWjPeCHOIe+6mu5R2S/H5fjDqD1jt57L0D9CNwhuQVXVXQ3br2Hi2WlTzurb5yCvC7OIoIugZsBDDkSoCH+da1YVkNKVNbX82/Mq4V7fb08NexStwJTY89+Htjy23EUYoyB3gxAdV+SJrGoECAWsH0mwK2148W0wx/AzD3MG78CNIttSImVCso3+Sugux39F7he65inI6iuB+f4jqk8MDP8lrm+av/N7/y7ds6b15x+K6GP+Iso6Zf9aW6jVWNlf8h5yA+kS1S3xrO12R2wnPTb8W9I9QV6O4YsZlxQ6AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image9_1_22238",
    width: 19,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAC5DOVpAAAABHNCSVQICAgIfAhkiAAAAO5JREFUOI2NlF0SwyAIhHdJ7n+uzrRncvsQQSHahhejwrf8OOHr8xYASMK8wvdAPl99S5CEs7WWg52FDFcPIFn8h+iJjRH0j2vpkBBf2EnyUjTrypF/gnrGDvVCfU/pggUwSIBTvQy/MlnyTWUmwKwckLyHlITm+LNmRRLQXE6GtrkFJKy3B1gMIMACQIAayoJwHEcNGTDv2Q3mR3MbwTGJ3JsOq+dmMZClsUZcevJp7py5aLTRwq3KbWEsUILVBTXHO2xTypP7mGa8aCC9pWrWe7qGeVkz7El2K6FHXrvJ/oNF2EPAFrZ8W+Vn+cu+mmGPxsrL71sAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image10_1_22238",
    width: 24,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAASCAYAAABB7B6eAAAABHNCSVQICAgIfAhkiAAAARFJREFUOI2dVFuSAyEI7GbI/U+0VbsXG/IRMSBoJcvPjNJ081D58/drJAEA5QukNRa/iMDMCj7iFMAExS8AGADC9zFt+te4gcfAm9lLgCREJGcRbcl8908wwgESel1X2w4zOxKfSKNfO3I0hF5hNPF2kgBZxUmojMWlmtoTCnjvoa45hD0BoaQ+qz4eJVtXSO0aGZcq5uxYBviqIJQeBZy0CB/2xjFKHKqqFbgI7MTu+w7cVmYAIFdwEigZm82ZiMgccowTEWhb6sYmdpyANbkukaNACjArRyvFbva3AuWNae5IIWx8W4Fj68IwvePrQ+fWT3gVaMQM9eJ1thXIbJ9Q9XGfCTj+H77+ln1Lvp62YE8i525uQM4NLQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image11_1_22238",
    width: 83,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFMAAAALCAYAAAADb7GaAAAABHNCSVQICAgIfAhkiAAAAnVJREFUSImlVm1y5SAMkwjv/nfaaW/VxPsDbGQgSXfW0+kLBvwhZAz/fH+ZmQEA2n8gxmbxDdE1Yd9jINh/hw32/64HiRCztqL9bW1CNGN+FZKwadwUpsqs81jMJF5OnsV/n49c3I/YIon6BORjAuYuBoTWA4QnaFd803KghAEGXB1X15nZCBTdT/gb9l3s8vUj7gSwtTiyzlDATgN0EId9c7DMYFwP+E6qA+PhFE/e9W5sYqg781MvTSlsJkAubCUAlpmlfXYQJhjgwBlHMtd1CTMg+9ugCBNZMnMhYDPAY98j4JkBLL5p5NxjKqWESddXlhKlFHyY2SobEnMd8G7Yv31/JBcICYgTWEm1fEgwAI7jyMml+e6Hw0DywKyzfuAen5JkEKos/sjVdl2ze5Ydc03YGmw2yyVPNpBn8CZdOY5RKXJwlOX9a4lND/3OPtAOQ6+1dJXIdTRfdfkKEp/9uxZhlYO1C3Vn+M7ReZ6JydqADi+PXdI7/WbNz3n2pRtWk8PHlAdnnd3fhGf3ofvc31ErFs8k6ufz2Tabuwb0tpYkam2EX5jojJUA4050LNUuVlaZGernMwcQraTtyy7jJbKJI+UgBNheJcnuqv/nMn8TZaJ3cX2KeF1E27HMHR3564BpBRIQTz3WXwy5AU27nJ1zo30QJ8uip166KRIugd6dkgYWayXA3RibcQNKB3v5kRJMcWkOm2vEkIFIwD2UvNu/xK92c5d6h/Jv5e0k+QJosHhj5w5PL8EUx53/3Zy+JX1M3vrzdTsAVf67zJd36CRz2cNyQ4qHvv/qg3xjr5SC67qeY5K98xvzrbGGjZcq3M3/Bc/Tof5cbttQAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image12_1_22238",
    width: 19,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAaCAYAAABVX2cEAAAABHNCSVQICAgIfAhkiAAAAZJJREFUOI2FlUF2xCAMQyWGuf/F+t70QrG6CHYEIVNWgcC3LAzw5/cjAJAESQAAAgAJAHi9XpAEjn4jARKtNayte4f1wdvEc3g/XjCfkMrWhTuIq802ax0pOMQD/NfuiQ9IRr0Bv6Ta0/hVQaYxjUvAxviCuZpc6KAd8Cn97oAVTPJUY/8JAGOqMAMLFhETLIGSEBIaCQFgawCvHXYR3f2qtCJmoyXEUBXHcQK/eZaKsPFCAyQJx3EAEXUCJmXuUYFGSpNfOh0iWeB1E7ovqHQjJpUh1VGT+Xn3zAYSSBIRMXZOlSrST9w3QBK6IpDA2lEHmLIqj6XO8rsnQLkgIQYsC0zNrgYfz0bGTcNLcSpaQMK4gqbjM9ZlkYKsuhKsuIcyXzfdZ1hMpS1KlWgNkqY6Sz87WwN9N4eqgg5Apf7lfjuVmeTLntFfy0GCyCugBe5P10kFAa6zaJemPyhVGu4Xl5+rlwTt1dmkOR1YN9ogrjaWE+Dp9zZ2Z31pdtVOEu/+rjirOS0nrbAce3oKz7Tn9gfPf1i44yI49AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image13_1_22238",
    width: 24,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAaCAYAAACtv5zzAAAABHNCSVQICAgIfAhkiAAAAclJREFUSImVVdFuxCAMs1O2//+5Sduv7FayhxLqpPS2QzqVK2A7iUP58fXp7g4A0Gf84A6XdzHqXgAgAJAAgG3b4O5ociI/XxicE+b3JGwqCZ6/wAYIC5iu65odqK+pVxKSh3IBVhJ7Rb0OvxETwLHe9p8fgLwcWBW5AtfCxzsKXnMA7H0h8aqsHl49674GAAt4OHIElaz3fokg1eCYoD2+v/XkJfx4E2m6c08SJ85sXXMoANpsJFMdLoC9zz1JAInWR/5r9XUeRiB5WLlGsYgqCNvj8bhtnpkSSRcBeLkOgmRGIeKa9z4VeFGTCHAWj2NvF/fFXhXpGDaNDr6koF5wGh2u9pzzgbX3Xmogijl5z5vSB3ntB/gwBY//Jtlod84AidQBjpGmMyV931NKCMLUTe7jslvhAzDJOQCYekB6ZGZgMZqZnS4qm1NjnYtnrXDasWJgiGumIU6wta/DANXWCTTemQHu47JbhBYev9RIRLD+j5SSJ8H729tT1ekyq/skTWamB+e02bblNMjQu2hFriR3o21CsBr1bkqdGk35xOothfaEoKYLAPZ9n2s6NCv/JgggIruukkad5hftPx+QRJaaLa+vsH4Bccto86RyfQEAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image14_1_22238",
    width: 24,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAECAYAAACUY/8YAAAABHNCSVQICAgIfAhkiAAAAJpJREFUGJVVkEFywzAMA1e2rCQ9+f8fa/uQZjzNDLYHSbGrC0WQAEiWz+8vE2ltQ+H5/EHBBIAoIiYoJAGkvwI6QsdU7o8PjuOgLIW67zuJgL238M6xY3HWJZEYSilDtJs46gC1Vlrb+n/b2mgAPDeZgq/fF0P+behFcF3Xnk/8MoxKXZdlkK/E06DdbmPy/CNOwXmeE2PwCyB/OEqqZvVDz+MAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image15_1_22238",
    width: 70,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAHCAYAAAC1KjtNAAAABHNCSVQICAgIfAhkiAAAAkZJREFUOI1tlWty2zAMhD+ATBN73Pvfq9MeJZYbS9j+IPiQG83YlEAQBBe7oP3681sAmOFmYIaZpckwDFB7N+M4AjOj1tJ8MKRo6zDMm9+IhbFtG9frpXm3cKfHLP8kpNXYPppNCFAIIfbnDgbFvc1bcxSgbpA44sDdUY9tOS8ROZJr+lpJ1FAeWiIAkzKpllwkQISIOAZAX1/Bcey4e4LXlll/ySQe24PL9cL9854xJzAdA0kUN0K5vu+JkBnbfeNy+VgWtUPuceDmlFrGvv1gCEIBQETMgoemj9kC5AQFoFoGGzknKJIgYlRVgAmCxpgGtojYT1VlGZXj5+e9R0CoF/eUUCmFiBjA93ywxsrtfu/UGjYM9tixvdlL8cFi0MmfEztI9i3nW+YBqpIxi8dkelZeibwA98Jx7BQv7BFzLlZKalC+eOG5P2duLAlo+rt733QwZkoM3A1Ldg6pepMugGeBzbxhYT7OYCOvZBU6A9HJMFGgTv1pBCHBUubpVkY1jgje3z/Y9ye1FqSCFMg0NlQICvx4/4FhxBYDmK7x8c1kzoktXY35cr1eeDz+DkDcHTNveXVZDMkshR2vTi+5dwmt0ut7dWD+T2hOeqJYax3MtGwkb29v6Tub81w/G4llhQYqPfzomFPbnTWjvwwOGbVWbj/bnu6FVbZaxuTtiZ2SGrNaQxkkWKXz+tRXQ5dW//liG7dKv4GMxb7MM6tmZtxut5Nt3/cumO+TqvUEzMDx9Zb6pq9Ztxs4drptXnvoa19Zn3/Mcq7HVpwQ5wAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image16_1_22238",
    width: 69,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAALCAYAAAAp30A1AAAABHNCSVQICAgIfAhkiAAAAdNJREFUSInFVtGO4zAIBOwkTf//Q9untHWw72FvLEJI2+vqdpEs2QMYPMYkfLlcGjlpbQf9Kv5TPsAlUjJz6MTMoe5/45/k9IkPcIkMLJOttT7eCfZJEt/Fv+MTSfal5NdwjMgRkaf2URL/ir/K6Uie6V7tld9JsNYaslpK6biqUkppE8jKuq4dZ2YS2b5cT771yzlvcOSDXIFjbuP4/T0B0dn5er22WuvOoNa6CQZRVSLaVklkZ5O43W50Op3CpDA/qpYje5CMi7BkeF97ARE53i9js4hxO2+tkSVPVenxeBwmAv9lWWieZ1qW5ZDEWmsnObpl7OFjqCqJCA3DsKkca+P3e4UR0VelRCSgUnzZghhr422PhifZYiklUtVNY/RNEmuL20pIKW10ItKfqr+8KAbyyZ4l72SNmZlyzlRKIRHZPDFPDNYiQqWUHSHwAb6u6y5udEAcEsPq4QPdM2KfNfycUqKop6Cca62UUiLYqSrN80ylFBqGoVcP7FW1N8JpmkIyoqrxB+hN7+/6fD7T/X7fkZNz7vbIw1eT3dvjvq8w89fXB6xGPQWs49YxH8dxZ2vFE/2sKYN8e7tWx8w0jiNN09Sb67ufXPj734eor0D+AIxdKtvCFJZhAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image17_1_22238",
    width: 70,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAHCAYAAAC1KjtNAAAABHNCSVQICAgIfAhkiAAAACxJREFUOI1jZGBg+M8wCjAA00A7YLCC0YDBAUYDBgcYDRgcYDRgcIDRgMEBAOE2AQ00VNvoAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image18_1_22238",
    width: 70,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAHCAYAAAC1KjtNAAAABHNCSVQICAgIfAhkiAAAAUFJREFUOI29lFFuxCAMRN+wPVGlau9/ou0FlukH2IEgLdmq6nzEwXHweMDW5/3LGKorGNwe3RpDswa74ubINRY9+hRvAJ71SVHBta1N/2YwPacNUv4z2c5NaOXULSg5LdbGGLlRXb8dMWP9H+zQi+xcJ38UughiU3sCgFrrVOxCpv8TMcfe5B7O+DORELLn07aiS0hhJA1JBkgrmX7Ckz8EzHXEDYXzQpjYN0z+R554FG2Y1jv8Rqv9jeEQDWisSmuN9NtYOgjYWLQWwlRdO0wPbxnbc0jCrs0vZfTIzaddhgKWDDsswkwi0E5tSq6VEKVQWnBLrTYRoheKa1LyQO/sW26tj3YUoqhA8JlmzGv4DUEC2xujU8uchbsC3W7TjKmOWeFsOXEIMgk0DMTA+2W+j0ut9NfYibvMuX/C9+OR7z8KuTq8UzCmEgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image19_1_22238",
    width: 60,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAGCAYAAACfHf25AAAABHNCSVQICAgIfAhkiAAAAKVJREFUOI21klkOwzAIRMfIl/L978Xkp0SEgpdGfRKSWQwY3MYYJAlVBcmHZDYApW9XLEc8Z/rKHv2+v+yO4ENrDRGzeZ8v4NlpqoqJebL8M7LeK/rsIkmICFS1TGrNiQhILotbfByix2r6vqohzHwZPRb2uiXLbCZRB3APaGfbFf53zWJPf8PXhn2Ck69iiMjjsX5TGdVgjNMHrejrkHf8MrR/cgEWWD7XgPu++AAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image20_1_22238",
    width: 61,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAHCAYAAAC7g0UiAAAABHNCSVQICAgIfAhkiAAAAX9JREFUOI3NlVFuVTEMRM847f4QLAAh1gxs5mWGDzv3PUFVqaqK8E/kG2fisSe++vr9W7LNTiDGNnaIjWMSsX2DgG22DQm2O8YhmViHJOzZS4IdTMbvGCeNl8YiIaj9Kz5A43WIr9UOSjBcmCFX3pnztkG6zjSn8MSYgABISKC1wLB3WGvhbSRRVcSmVFhBJeIgRK3CGVISANULkQgiEmACCD3c3n4ESqi12PuGJLok97Whu3BSnyHh0STN2b/tSRJUgd2A0ESSJpgQTFU1UNIEKpRFN6SuTms6t6XuoIIIliCHlHCC0vcw3ewMgxEE1lqQdENGYbGHdOeaBEnti6vYyUt0h/RjZR6B/vx+mtJFOcWYggcqkHH0/ExdzyDcvBvnkKao80QOqZF7F+48lSE1ytGDEu860asEXyX9kVZVhKPAoMlROtp/W9Lvzuef3vaf2DW/3mqfvnyeaXgm630yZ6R75P3S9M6DvM+b9rV/5D1/gNwnb2x+/fj5LtK/AVBjpls3mKnIAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image21_1_22238",
    width: 10,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAABHNCSVQICAgIfAhkiAAAADtJREFUGJWNz8ENACAIQ9Ff4/5zEByyHuUigWtf2qA4aQa3Jghgd6H9xr6NFbVQ0ny64vEzAgwQJ1t4AdsxDAuYiQjfAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image22_1_22238",
    width: 4,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAAC9JREFUCJlNysENACAMw0C76v4DIpgFHgGJPC92rLlVVEC6qsiC/V4RfkjBBSSBHDEuA9FuSbtaAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image23_1_22238",
    width: 8,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAABHNCSVQICAgIfAhkiAAAACpJREFUCJljvHTt6n8GPIAJnyQDAwMDCzbB//8RhmKYgCyJVQEjIyMKHwCwegmFpzUzUwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image24_1_22238",
    width: 7,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAFCAYAAACJmvbYAAAABHNCSVQICAgIfAhkiAAAADlJREFUCJlVzcEJACAQA8Hd9CNo/8XpQ8XzdYQJOdvoU0Ul2VfFhLxQwOzyhVQ4xfzwFoAye/5cAFj/fwIDNRfOSAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image25_1_22238",
    width: 4,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAACVJREFUCJlNx7ENADAMwzBZ/x/rD9ypQLgxbaeSBBUBtvF5A/AAPGIJ3kkcwTcAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image26_1_22238",
    width: 3,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAGCAYAAAAG5SQMAAAABHNCSVQICAgIfAhkiAAAABVJREFUCJljZGBg+M8ABUwMSIAcDgBL2AELrf+bNwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image27_1_22238",
    width: 5,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAABlJREFUCJljXLF61X8GNMCELkC8YERoGAMA92cEB1pWOdMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image28_1_22238",
    width: 6,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAABHNCSVQICAgIfAhkiAAAABlJREFUCJljvHTt6n8GLIAJmyA9JPS0tBkAB3MEC3dIfZ8AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image29_1_22238",
    width: 6,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAABHNCSVQICAgIfAhkiAAAAEVJREFUCJltyzkKwDAQQ9EvMzcyhNy/cZNcaeTCS1xEoEYPqd6XncZObI+mCUkggAIkAIgJe9OAsmAfvlcA/GEwc+LbHjpp2xkaP6peUAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image30_1_22238",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAACZJREFUCJlVyLENACAMAzDD//92a1iKEB69qiqQRHfbRhJ4cfMLOASiD92C1ROyAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image31_1_22238",
    width: 4,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAABHNCSVQICAgIfAhkiAAAAB1JREFUCJljfPfu3X8GJMDEyMjIgCLAwMDAgCwIALjIA9U00hGdAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image32_1_22238",
    width: 25,
    height: 55,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAA3CAYAAAD5T+ElAAAABHNCSVQICAgIfAhkiAAABJtJREFUWIWdmN2W4yYQhD9AtnceMJvkXZNcJbnLzORp7LGgOxfQ/EmyveEcHckW7qKqmgbsAGVqv/3xOyKKqiCqqNhdEZXNXURIKaGqiOTPACEEQggsMwCAcw7nABz5ZnfN30x3lzsDVAAAVUVV8Ycg3hWwJ1cB8c4jIjjnSCkNQMdMBgb7d3UOZ2zKoGz0qs2FQxAPiPN4BHEOp1Nw1SxTeaeqoFQWBvJYLvOlk4ZOnuE7l032wdfglgA24KH9+fdf3Y+3QfMrV1nZM4WNc24wX0S2IDUoM5uSa1Pw9txUsOCqivd+R649qTrANogGWluZJ33bZ9IH7dlMzApil8q5Tw9krHZAJjYTEB2LxogKmkTwBfJQro0sfXDzBXtu7yQlvm63nF1ujHloPBZ8CmhKVdrlnYjWF6LKsiw1nXeM7+BqwJ7VLFsOmkuZ4pSaxiGEfePngJvgO1IBaBKSKNIV9UMmbmDSi+u6mK5+BlARtJ8nqgQfHswTLHUfjX64AY7b7UZMEUQAh6L7KfzP+3vzu7IZ51sPbdTv6z0HK52VsRI/MH7vhetVAiDGmB80l3zLLMhF87AKbyU7wm11qr+nlGxNzdX5NRb7A4kxcr1euX9luZQiGbCcluOy8n9blQ04n885uM/hx5Vxs295FHTler0SYyRJqul6Pp85nU6VxeEaT84P9AmoihBjJK4r3oc8+uAJIVQA6OR6//x4wkbzpbDGyHpfx8nq4PLtwlIA+nd+DKMZQ7tvlF1GCtzvdySlYWDB5w1d3QPQeaJ94EEqbWBAShE0G51SQoEQPMv5jMPl3ta5Z/Lx+VkCjcF1oJB/KKLcrtdaw0QEvAdVTucTYckstEPxNnaTfAabgUtvbrcbKcW6SoYQCN7verp8/PuZN9fmyK4fGXhdYwNTcN4TvOe0LCzLibL/mxQAryWSjdiKW8uA5gco9687MaZqpK2kYQksxXBToMlVA49S6SCbDcS+l1Jt2zvIK+RsemUyXgzMDDglIca1nEGytLaxu7y9DX4oO3KNkmljwQwGKUkdvfeBUDYMCmXbtXV+w4QdRnaayqU816gcLPfvjwyzH79+/7kDmUdf7xlsXWMdqZIzyzvPt7e3utucAawtW0+28tnmOcZY0rqY7TMDZ3k4HX4qiGgOoGIBtQZSLTsRtXRtWee953y5ELwv/eWwuFYmln6WovmzEFNCUkJpjOaR1+cDlM74kZFOcqVpHV9Op7LUujo39qSqTGQI3MBSks15w5VTlZXyPlGO2mJ/Csx+5LRNZSKmksLZC+ddWb9d9WKPxS8/fTcmPUDnhyipeGBXCD7rX9i9wmJHrgwgqbGQ8pcHtDkSQkBp58IjLzq5Wsck5f8SSc0LbSkrInjnaqF8ZPaGyQxQ09JOsCWwNdEm1yttqVKVgDmI5rlhYOTJ9qhGPWFSfOjnhklovboaZjI+A7DMakxM397IcpiBbbV4lcHAxMpKKy2UmS8Dw1eN3oAMQWgFcQ/ADH/WeqkyiEi3OGUWVpmhK4IvMpgB4Gg9EQX3+mR7BFCZ2CI0lHv5MQaP2uHK+KMARywA/gMKZEa3CEWbRwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image33_1_22238",
    width: 6,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAECAYAAACtBE5DAAAABHNCSVQICAgIfAhkiAAAAC1JREFUCJl1ybEJADAMxEDpF/D+g7p10qUw5ECV7O4DkISZeQVAZYv6H1tVcQFcNQ0TW1v4wwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image34_1_22238",
    width: 27,
    height: 51,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAzCAYAAABmK3MOAAAABHNCSVQICAgIfAhkiAAAAxFJREFUWIW1mG1u6zYQRc+QlNUkO+krXve/jQLtUqzaJGf6gx+WX2nHsuUBAihCoMO5vDMcRgBjEH/98/fo9beRc8bMSCn1d845gve4p754JwRQVQRIMWJm5Qf2hyGCWRHLoD/zDpiqghmpytlgqro/zDmH8x5TBcoeqmp5vzcMMzRnoGZZI+c8hj3rxFGoKmb2nswMUDOyapeyQfeXkeJAUyVXs4gI8A7r10g5d4iZ4d9R1CkllmW5SFiB8IbMcnUilH0K3vd62xXWLL8u5lyBbzGI5lwKedWm2tO+mdWGCxRzmOGde08HMTOW45EUYy9mo7QwGGT2Svc4nU4AiHOISClw1d62dsusHZZNRs2ZaZoACCHs60Yz69Jprh0/pV7YIQTCHqAYI8fjkXOV0TDEeQCmaSqS7l1nACleZo/DPAPgbxlka7SsYoyknFFTvHP8Ns/M80wIVTyzfWRs01SMkeA9Uk9r7z3eOWSU2Vbbp5Q4n8/dBACI8PHxweFwKL+6C+IlGVv/O59OvS/2DztHCAERef08a909pUSqz8F75nm+znS9gPawVUJVZVmWvvKs2iWb55mpZjWEPRMiwr/LUoqXAg0h4L0f/n2A54yxXrXUWX4+HIbGuII9E6fTiRTjBdigIfSe+Gu4V7q8Mc5gPd9fwbYCNGdivZ30o6MW7ufn56Vj7AHrUNW+b977K+m+tf6jgHYNEpHSYFeS3YIA/Pnjj+0GSTH2IwPAeY+I8PX1ha/Pt2KbjHWmyKsrLIC7A3gK1swgcDXleu/5fCAr2FBna/f1fVo12Udi056ZWRk+RbA6Cx4Oh3JpGNTbUzCt9+PWdEWk1Ba1xh7M7lvY2u66upSHEHAi5f8b32T18/cfj8Hg/+1nCgFxrrzfsGd3l2Rm3QwNKCIdME3TQ3vVYpjZ2nVWASKCta5BGc+2OHEI+9XewmWkvjoUN4KGsN6K6pWn361WcsmG+mrmGMJGceuzL8u4brK3PvioKdZZwQ03NsDoFN6azTqGMl4NMzXTvoAn9uoubA2Bx2W7BwL4D+NBvROuZancAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image35_1_22238",
    width: 9,
    height: 11,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAALCAYAAACtWacbAAAABHNCSVQICAgIfAhkiAAAAFBJREFUGJWFkMsOwCAIBGeN//+1eHV7otHWB5cJZLIQBLi1hiSAl2OViADA9sRJWglfseyEUTwmJa9JvXdqDiRNHNfVm7C96feC2022z0nZP6FccndXAswXAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image36_1_22238",
    width: 13,
    height: 20,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAUCAYAAABWMrcvAAAABHNCSVQICAgIfAhkiAAAABxJREFUOI1jZGBg+M9AImAiVcOoplFNo5qGqiYAcxABJ/GZGIwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image37_1_22238",
    width: 12,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAABHNCSVQICAgIfAhkiAAAAE5JREFUKJG1kzEKwDAMxOT+oOT/b1WHNOB2KOlwxnCT0HlwnWOIIjL3lQrMVDn4OdvAMuUMWWD1zxmyQO+fMdyasMFm+QQeB1dtGto/AFw6ESswpQHviwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image38_1_22238",
    width: 3,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAABtJREFUCJljFBYV/f//3z+Gf///MTAxIAHcHABDFAc690FgAgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image39_1_22238",
    width: 5,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAMCAYAAACqYHctAAAABHNCSVQICAgIfAhkiAAAAFBJREFUCJltjkEOgDAQAsH4/7+Z6G8axoPd1KbltBlYgq/nRpJsq3TUAazwr6MS2/cpWX1Lp+0JnklkezJG525SQCQDttbUd30wiQRKTwF6AcTTLmRPP1A0AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image40_1_22238",
    width: 17,
    height: 15,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAABHNCSVQICAgIfAhkiAAAAJxJREFUOI2VUcERBCEIS5htwv5Low+4h8OdsuCNeQYNISEABwBVRcDdUaHjqarl5EZISILkW/2Cf9ZhtYkk3L3k471UmypkPkRJznNOllcH3YlyGlZi7j63y++IJ39aH2d0uZSZZFeZy0G3FYtIm4uIbNxW8anG7CAyeVV8CjjjquJ1ntsys+mq21QJBMxsE5Qxxt9T1rzM7Osi+A9eY2sJJNgZEwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image41_1_22238",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAADBJREFUCJk1xrENwDAMwDDJyEUFiv7/mJWpnOjzvbUBUMuoOAKgcv44UnFUKBhh4QIa1g2xugE2+QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image42_1_22238",
    width: 9,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAABHNCSVQICAgIfAhkiAAAABZJREFUGJVjZGBg+M9AADARUjCkFQEABigBDWVOulsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image43_1_22238",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAAC1JREFUCJk1yrENACAMBLEjv/8QCObMUaC49tr3CJCEJJQKgIpKdTdD/WMWwAMnOBfpEwBUQgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image44_1_22238",
    width: 5,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAECAYAAABGM/VAAAAABHNCSVQICAgIfAhkiAAAADdJREFUCJk1yrERgDAMBMF7Wf03xgw0ZHQEwMab4zpVUelu1lr0zACQBBWUqoR7b/4tUADCuz4P7JkfZjyNzbsAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image45_1_22238",
    width: 13,
    height: 8,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAABHNCSVQICAgIfAhkiAAAAH5JREFUGJV1kGsKwzAMgz+Z3v96g+0qibQfbdompQLjYNAj0uf3TRLu03uHhABJkEQSSkJV1EpIAgASA6216Va84RCwDWMfzmX74VI1awWIfQps9+xntMlwvzmhEqhieyP4Hg/OMtjJ+2OFELYpid7a9YVRxEqRhOpqb6QZ+AOfOY8SzqppXQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image46_1_22238",
    width: 12,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAABHNCSVQICAgIfAhkiAAAAF5JREFUGJVtTkEOwDAIArL/P7OvaGGHxaVz9YIQETjGCLZJHmobSV5eKLQhedxtgyS0i/shyV+abajEbpT00cpw9e6Fp9RPQq9TVQBgrYUkkAT16N0o6fkqYc6JJLgBgxdImqQnXCMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image47_1_22238",
    width: 4,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAGCAYAAADkOT91AAAABHNCSVQICAgIfAhkiAAAADlJREFUCJk1y7ENgEAQA8HxiY6QEP0X9iY4EW0ym/t92lZPURckkYm2riS0TDiMJbZ2UTKR5Bd2wwfe4BG4NbINgAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image48_1_22238",
    width: 10,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAABHNCSVQICAgIfAhkiAAAABZJREFUCJljZGBg+M9ABGAiRtFQUQgA98gBCyfBSi8AAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image49_1_22238",
    width: 9,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAABHNCSVQICAgIfAhkiAAAADxJREFUGJWNjcEJACAMA1NxAN1/Sx3gfBj8WT0CKfQg0XoHoR03SHKDijIs51KEeEomlfiaM/X2mGOcewFY9xgGNm2sCQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image50_1_22238",
    width: 14,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAHCAYAAAA4R3wZAAAABHNCSVQICAgIfAhkiAAAAIlJREFUGJVtkEkOAkEMxOyC/wG/ZHtjikOzjEb0JUoiu5T29nxURQXgkKDB7GeSd9VwbMvnqUxLGJiAxYRpEaAlQBmOq//BAAPIIJIZUMyBzjAJlgXuYZVOIUsSZbpEzqD+wC0876WVdqhCAQsJbBP/JQ9L8BVtEgV6fdz3PAAxIOs3EV1nXE5nXivMRzC/McqRAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image51_1_22238",
    width: 26,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAyCAYAAABCtcuVAAAABHNCSVQICAgIfAhkiAAABT5JREFUWIWVl92S47YRhb9uQJJn9trJOyRVfv/nSCVxUskLuJxaO1nPjkQC3b5oEARFcuxABZGCCBye0z9oyD///S/HodSKWeV6vZJUSTmTc0YARBAEiR9P1/X+j9/+gbOWkyqlGuDLFABUFfkQ4AjwvOVaDbO64FBrRTWDGZLzDkhEtiBxWb7OgRxHRHBxxAU8fktKDWQE+oDVbzBSEaHWipvj7v3FYtHjrkdXFT7//PM5IxxyytRaobET1Q2bxVYsv5d7Finpv0+Bck6UUnA3HBBVkqbVGU6AJG7a+G+Ll0utVAuQWipFCiUVck6IpCeQY6DFTh9h6e16I6fcZABVQXWwyTPIod202UrPgQIBRBTVRCmVt7evMXgEwhHQ+nKnQOIO7uScAKeUGRG439/b4gvkMwjd68Z+aiMQ3MHMMfMmQ7BjWLw7Qie6BO7WdqeMjIgds4oIuEemUBGs1v6g9O9mtxMJH9N0DKSyZgN3x81wd+YyY27dVGPfSjrAfyBfd5OUEh6BxPSYaKYbrdM/e8S1fwiUUgYHb8wA3t/fw9inqm/byO4U6HLJkecAqzWyQ0q83+/M8/y7gHzoRy0DmFkPVqsBNs8TtV4x90hNp0sMSB801ZQAuFyvMZC0s7vf75QyU2vpNjvtgON97g4IIOcL7nC73nCLB91i9uP+oJb6NG0Vyn3bzZ3H9NhLp6I4zuVyQVX5+vUrqso0TyBw48b9cY/7661Nkw7YomPFl2MZFRzR2LhySnz69IqIkDUxPSa+fPmFeZqbPM8M2LFxN+xAPvWmQtKEN1u9vr52X1URVBXcKXMJwXaLB8A4vpPOB545ZwAeQ8CaG4/pQUqJl5eXdbt/kqur5iBywGi1q/c8t1hAVbEabzrNU9QWZ2zMscbKzPnfly9P0tE+S7oRIV8y19sVd6fUyuMRXvT29sbj8RjAbAvYwWwnn/ZJzdAiEUc5Z3KLsdgM307Y+AFYAP7037UqyqF1s5SEXJfLlVIK129ucI9yeTEHONM0cblcIz8KiAPi+LIjHbl3l21gBvDy8oJqmFCa57k79/sds9HLwp3dlntrjKL/5/Pn5nXNi9yl57OUEqXMmBkQO0A1Y5omUvomePUcuCgijdkxpbwYbeOxg/YCPQBFhGqGmTHPUZK5L+VWgI0YS9b44ccfB2cYIh0JVq+vr902Xo1S5uYc8zYT2OiFa+Cu474yWmVYWAVoyhkrsWhSpZZKSinqCl82aMd9KY2Pt5QnRquLggerT59aWUV7y0otFWspyQZmW/fe9s6o54/2Pj0/u8FSuLRJIV8h54yasprGB1/Ybuor0GGLuLhdrjzmKVxYnVILmYynCEwZZFtX2667A9pxEkFzhnmK7GGRbZdMMM9zS8aje+9b7vHw9NACuNTVOV9iWzdDzdDk4eK6bP0t1H1dZAyZgdFz0LXR9ndKiVpLPOdx1s1ZglmppLR64JF42VpQjlwC0HFp2aKxivrPqG0rqVJxdRTfFI5HNaQA/td/fN8eWE7ZT1cEs0ophWq2lsCq5Etez7Kqw7LblkOeLV3ZXT2KypyhtO3cDMGxWvF2DHVi6z/MdRug2If7dSmRHaAdP5cXkJQi6bqTmgdWc0yDzcpuABrZsMnKA3hrqhqVrXvfOnrSxfEaJjAPFej/tfX/8ve/7egubTS0t6plEWex5fOzz0eYDaOztgvqJ5v2t5bzCn1juY9YjW2xzc6P25iwt9H5ef2Dpqqh/1PrY43Z2He++HtZwSrheIALnH0cHTr9/wM2Ap6BfPenP/MrHrdKGF7DYuwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image52_1_22238",
    width: 20,
    height: 34,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAiCAYAAABfqvm9AAAABHNCSVQICAgIfAhkiAAAAadJREFUSImtlUGugzAMRMd2yqbbHqD3P1hp1W2RCJD4L/qdhqhBBDUbSwEe4xkH6Ha7KQAQEfbWy+WC2uJ5ngEAqtpUq0BVbYY9n886cJomhBB+p9CAv2qbVRXjOGKapt2wTeDr9UJrMADweDy+A4kIIgJVxbIsv0nZew/v/W88jDECAOZ5Xvmzp35rm0MI8N6DiDAMQwIfVcoAEELAMAxNEKv3+30NPJ1OUNXVWT2S+kohM4OZAQDjODYrzVWyqVLVpuGuKWVr1cCW+rIsTbC+79dAVUUI4ZCHK4XOOTAzYowQkaTMlLZA+74Hn8/nFIoNtn19WttW1ffRs4Rtk4gOwQCAmRld18E5lzZjjM3HMCkEkGA2PvlNrUrZ/Ou6Ll2wtA95CLznT0TAzCAiEFGCqmqyYA/U/cuEiMA5BwAJZmnbPbkttfqJF5+TYqnnA7v3R+bsARFJ7ZYJ20usbilMQAMY1PZsTnMviSj5XUIT0CAiko5dDs5HqhSw6WGuslSbr+ocoljWyp6Hq3NYW6XKPUq/AvNfQvmCLdj1eq0rLNWVX/Za23/ZQ/njVzlyJAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image53_1_22238",
    width: 15,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAACEnoQPAAAABHNCSVQICAgIfAhkiAAAABxJREFUOI1jZGBg+M9AJmAiV+Oo5lHNo5qHl2YAk3QBI0lyghoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image54_1_22238",
    width: 14,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAASCAYAAABrXO8xAAAABHNCSVQICAgIfAhkiAAAALBJREFUOI2dksEKwzAMQ59DP2iwjbH/P47BfihWD2kS00NjlksgtixZkT3fL0kgOZhhEjLDAAGtCGLev8+XIvqj4Gg2M1an0Prn9HBfA/88RfLJkGCajHGfxG4At8c9SD3IjJw5G9FuB1mTvIKepObllgGgfUOtNQ/sO3V33T0H7LGKinNSFeMDmC3TUzqHBkrIk5GLRrr6gARwtrUJNWNOCXRCIznufrnndi41pWupOzgWaXyOzgXJAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image55_1_22238",
    width: 4,
    height: 5,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAFCAYAAABirU3bAAAABHNCSVQICAgIfAhkiAAAAB9JREFUCJljTExN/s/wn4HhP8N/hv///jMwMaABMgQAaxMIK6SjElwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image56_1_22238",
    width: 3,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAAClJREFUCJkFwYENACAMw7AU7f/fkOCddHbuf61iyyShCQEGQEXlqABUWWs7Fmr54jDJAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image57_1_22238",
    width: 17,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAABHNCSVQICAgIfAhkiAAAALZJREFUOI2NU0ESxCAIS5g+wEP//0VfQLOHHXcQ0a6nSiCBUNl7lyRU5xS/7/t3Z+9d/xSdyCaSU8EJsyqJZJm8ixvJBYyKkqZ7lW8R3KlXWIxbBeZudgIDs1wUfcmxHaFVwCgyswkb33lEi8aRxPM8C9nJFwC44jiRICtn4phjQ736kd62Mo0zFNx9AiXBbFngInAN5tx6ZWg1Smvtux13h7tPvpBcutgZ/Bsnmyrp9Q211gAAH+OdgWfMzyynAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image58_1_22238",
    width: 3,
    height: 3,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAABHNCSVQICAgIfAhkiAAAACZJREFUCJkFwQERgEAMA7Aw/AvkQMp3Jbme761yEnPPKKhJ1m4oP1YLEH818em4AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image59_1_22238",
    width: 3,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAABHNCSVQICAgIfAhkiAAAACpJREFUCJkFwYENACAMw7B0/9+B4Mg12Dnv2pbdZdqiojJJUAEYlSQk4QMdIBfmsp9mrgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image60_1_22238",
    width: 4,
    height: 4,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAABHNCSVQICAgIfAhkiAAAADFJREFUCJk1yLERwCAQxEDd039/jGmFHxFglK0y16fK3g1I8VKSUElQSNUdAONHd3MAF2sRkNHBAkYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image61_1_22238",
    width: 12,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAABHNCSVQICAgIfAhkiAAAAH1JREFUGJVVj0sOxDAIQ59p73+4kaaXmcSeRULVIrEw+AP6XN/YJgljDI7jQBKSAF5YEieAbWxDgm2q6iYkAYAEJGrOSRI8jRPS7WzexkCAsweO347PapFEiUXqm1uwPNlmGyVUOwOM30Bo/fMQd3ISqqpugEDiTnw+Lq3lH4PdejyScEfvAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image62_1_22238",
    width: 14,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAHCAYAAAA4R3wZAAAABHNCSVQICAgIfAhkiAAAAHRJREFUGJVtkFsKBTEIQ48yG+j+V9nvweR+XCylHUHsIybRmHNaEpKoKjKTiFiZmdjmjNxBwFX7vN8BHoCqQhK2kbRUgU8122Q3VBW2V0q6VHYHj6SL7QQBnLiMCGxfczRBO9itjzH+Vvvxfd/12YRfiwL4Adh8Wtv18V1eAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image63_1_22238",
    width: 12,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAABHNCSVQICAgIfAhkiAAAABZJREFUGJVjZGBg+M9AAmAiRfFw0QAAKPcBC7wt6nUAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image64_1_22238",
    width: 11,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAHCAYAAADebrddAAAABHNCSVQICAgIfAhkiAAAAFRJREFUGJWNjkkKgEAMBCv5kyD+/6DgmywPcUWGMZeEdKfSMUyjbgIiEPDqKlhqoqV0SiVrOgi1bR7kFeAwCUR8X0UEyQnkptugZz/tw7zOy6+8ADtTGC7uxEr63QAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.be74f322fa07a5e6f609a70c71aa8ecd.svg";
export { ForwardRef as ReactComponent };